import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Modal,
  Collapse,
  notification,
  Popconfirm,
  Pagination,
  List,
  Spin,
  Tooltip,
  Tabs,
  Dropdown,
  DatePicker,
  Select,
  Checkbox,
  Input,
  Switch,
  Divider,
} from "antd";
import discountCalc from "../../../../utils/discountCalc";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";
import TableComponent from "../../components/TableComponent";
import { MdDelete, MdArchive } from "react-icons/md";
import { IoDuplicate } from "react-icons/io5";
import { FaSquareRootVariable } from "react-icons/fa6";
import { HiDocumentDuplicate } from "react-icons/hi2";
import { FcDownload } from "react-icons/fc";
import { useNavigate, useSearchParams } from "react-router-dom";
import AddNewClientComponent from "../../components/AddNewClientComponent";
import { FaInbox, FaFilter, FaLock, FaPaperclip } from "react-icons/fa";
import "./BookingInfoContainer.css";
import moment from "moment/moment";
import formatIndianNumber from "../../../../utils/formatIndianNumber";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyDraft,
  setSideTab,
  saveDraft,
} from "../../../toolkit/slices/inventories/inventorySlice";
import { PiPencilSimpleFill, PiPencilSimpleSlashFill } from "react-icons/pi";
import { MdDeleteForever } from "react-icons/md";
import isAbleToModifyBooking from "../../../../utils/isAbleToModifyBooking";
import yellowSpotLogo from "./yellowSpotLogo.svg";
import PendingBDFContainer from "../PendingBDFContainer";
import dayjs from "dayjs";
import accessCheckPromise from "../../../../utils/accessCheck";
import AuthorizationError from "../AuthorizationError";
import ReactQuill from "react-quill";
import { IoIosMail } from "react-icons/io";
import { addProposalInventories } from "../../../toolkit/slices/proposalInventories/proposalInventorySlice";
import {
  addBlockInventories,
  emptyBlockInventories,
} from "../../../toolkit/slices/blockInventories/blockInventorySlice";
import { getInventories } from "../../../toolkit/slices/inventories/inventorySlice";
import filterSearch from "../../../../utils/filterSearch";
import createBDFExcelChanges from "../../../../utils/createBDFExcelChanges";
import isEliteUser from "../../../../utils/isEliteUser";
import generateMC from "../../../../utils/generateMC";
import generatePC from "../../../../utils/generatePC";
import convertS3ToCloudFront, {
  openFileInNewTab,
  getViewableFileUrl,
} from "../../../../utils/convertS3ToCloudFront";
const { RangePicker } = DatePicker;
let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const BookingInfoContainer = () => {
  
  let userId = useSelector((state) => state.user._id);
  const [bookingsModalOpen, setBookingsModalOpen] = useState(false);
  const [BDFData, setBDFData] = useState(null);
  const [subBDFData, setSubBDFData] = useState(null);
  const [fetched, setFetched] = useState(false);
  const [access, setAccess] = useState(false);
  const [draftModel, setDraftModel] = useState(false);
  const [drafts, setDrafts] = useState([]);
  const [draftDeleted, setDraftDeleted] = useState(false);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [clientOptions, setClientOptions] = useState(null);
  const [createdOptions, setCreatedOptions] = useState(null);
  const [campaignNames, setCampaignNames] = useState(null);
  const isElite = isEliteUser(userId);
  const [filtersBDF, setFiltersBDF] = useState({
    client: null,
    createdBy: isElite ? null : userId,
    campaignName: null,
    dateRange: null,
    createdSO: false,
    notConvertedSO: false,
    stamp: null,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "1");

  useEffect(() => {
    // Synchronize the activeTab state with the URL parameter
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "1" });
    } else {
      setActiveTab(searchParams.get("tab"));
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // console.log("URL Params: ", params.toString());

    setFiltersBDF((prevFilters) => {
      let newFilters = {};

      if (params.has("client") && params.get("client") !== "null") {
        newFilters.client = params.get("client");
      }
      if (params.has("createdBy") && params.get("createdBy") !== "null") {
        newFilters.createdBy = params.get("createdBy");
      } else if (!params.has("createdBy")) {
        newFilters.createdBy = isElite ? null : userId;
      }
      if (params.has("campaignName") && params.get("campaignName") !== "null") {
        newFilters.campaignName = params.get("campaignName");
      }
      if (params.has("startDate") && params.has("endDate")) {
        newFilters.dateRange = [
          moment(params.get("startDate")),
          moment(params.get("endDate")),
        ];
      }
      if (params.has("createdSO")) {
        newFilters.createdSO = params.get("createdSO") === "true";
      }
      if (
        params.has("notConvertedSO") &&
        params.get("notConvertedSO") !== "null"
      ) {
        newFilters.notConvertedSO = params.get("notConvertedSO") === "true";
      }
      if (params.has("stamp") && params.get("stamp") !== "null") {
        newFilters.stamp = params.get("stamp");
      }

      return JSON.stringify(newFilters) !== JSON.stringify(prevFilters)
        ? newFilters
        : prevFilters;
    });
  }, [window.location.search]);

  useEffect(() => {
    if (!filtersBDF) return;

    const timeout = setTimeout(async () => {
      let data = await fetchBdfData(filtersBDF);
      let dataSub = await fetchSubBdfData(filtersBDF);

      if (data) {
        // console.log("data is: ", data);
        setBDFData(data);
      }
      if (dataSub) {
        setSubBDFData(dataSub);
      }
    }, 500); // Small delay to avoid premature API calls

    return () => clearTimeout(timeout);
  }, [fetched, JSON.stringify(filtersBDF)]);

  const fetchDrafts = async (page = 1, size = 10) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/listDrafts?page=${page}&size=${size}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const data = await response.json();

      setDrafts(data.drafts);
      setTotal(data.draftCount); // Assuming your API returns the total count
    } catch (error) {
      console.error("Error fetching drafts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrafts(currentPage, pageSize);
  }, [currentPage, pageSize, draftDeleted]);

  const onPageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    fetchDrafts(page, pageSize);
  };

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    fetchOptionsForFilter();
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  async function fetchOptionsForFilter() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/bdfFilterData`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      let responseJson = await response.json();
      setCreatedOptions(responseJson.data.createdBy);
      setClientOptions(responseJson.data.clients);
      setCampaignNames(responseJson.data.campaignNames);
    } catch (error) {
      console.error(`Error in fetching Options for Filter: ${error.message}`);
    }
  }

  async function fetchBdfData(filtersBDF) {
    try {
      let query = [];

      if (filtersBDF.client && filtersBDF.client !== "null") {
        query.push(`client=${filtersBDF.client}`);
      }

      if (filtersBDF.createdBy && filtersBDF.createdBy !== "null") {
        query.push(`createdBy=${filtersBDF.createdBy}`);
      }
      if (filtersBDF.campaignName && filtersBDF.campaignName != "null") {
        query.push(`campaignName=${filtersBDF.campaignName}`);
      }
      if (filtersBDF.createdSO && filtersBDF.createdSO !== "null") {
        query.push(`createdSO=${filtersBDF.createdSO}`);
      }
      if (filtersBDF.notConvertedSO && filtersBDF.notConvertedSO !== "null") {
        query.push(`notConvertedSO=${filtersBDF.notConvertedSO}`);
      }
      if (filtersBDF.stamp && filtersBDF.stamp != "null") {
        query.push(`stamp=${filtersBDF.stamp}`);
      }

      if (
        filtersBDF.dateRange &&
        filtersBDF.dateRange[0] &&
        filtersBDF.dateRange[1]
      ) {
        query.push(`startDate=${filtersBDF.dateRange[0]}`);
        query.push(`endDate=${filtersBDF.dateRange[1]}`);
      }

      const queryString = query.length > 0 ? `?${query.join("&")}` : "";

      // console.log("Query String is: ", queryString);
      let apiUrl = `${apiBaseUrl}/inventoryManagement/getBdfData${queryString}`;
      if (activeTab == 3) {
        apiUrl = `${apiBaseUrl}/inventoryManagement/getSubBdfData${queryString}`;
      }
      let response = await fetch(apiUrl, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let responseJson = await response.json();
      let data = responseJson.data;
      return data;
    } catch (err) {
      console.error(`Error: ${err.message}`);
    }
  }
  async function fetchSubBdfData() {
    try {
      let query = [];

      if (filtersBDF.client && filtersBDF.client !== "null") {
        query.push(`client=${filtersBDF.client}`);
      }

      if (filtersBDF.createdBy && filtersBDF.createdBy !== "null") {
        query.push(`createdBy=${filtersBDF.createdBy}`);
      }
      if (filtersBDF.campaignName && filtersBDF.campaignName !== "null") {
        query.push(`campaignName=${filtersBDF.campaignName}`);
      }

      if (filtersBDF.stamp && filtersBDF.stamp !== "null") {
        query.push(`stamp=${filtersBDF.stamp}`);
      }

      if (
        filtersBDF.dateRange &&
        filtersBDF.dateRange[0] &&
        filtersBDF.dateRange[1]
      ) {
        query.push(`startDate=${filtersBDF.dateRange[0]}`);
        query.push(`endDate=${filtersBDF.dateRange[1]}`);
      }

      const queryString = query.length > 0 ? `?${query.join("&")}` : "";
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getSubBdfData${queryString}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let responseJson = await response.json();
      let data = responseJson.data;
      return data;
    } catch (err) {
      console.error(`Error: ${err.message}`);
    }
  }

  const columnBookings = [
    {
      title: "Serial No.",
      dataIndex: "serial",
      key: "serial",
    },
    {
      title: "Booked On",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
      render: (text, record) => (
        <Button onClick={() => handleViewBookings(record._id)}>
          View More
        </Button>
      ),
    },
    {
      title: "BDF",
      dataIndex: "bdf",
      key: "bdf",
      render: (text, record) => (
        <Button onClick={() => handleBookingClick(record.area)}>BDF</Button>
      ),
    },
  ];

  let tabs = [
    { key: "1", label: "Bookings" },
    { key: "2", label: "On-Hold Bookings" },
    { key: "3", label: "Sub-BDF" },
    { key: "4", label: "Drafts" },
  ];

  const tabChange = (key) => {
    handleClearFilters();
    setActiveTab(key);
    setSearchParams({ tab: key });
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case "1":
        return <BookingsContent />;
      case "2":
        return <PendingBDFContainer filtersBDF={filtersBDF} />;
      case "3":
        return <SubBDFContent />;
      case "4":
        return <DraftsContent />;

      default:
        return null;
    }
  };

  const dataBookings = [
    { serial: "Booking 1", date: "Jan 11,2024" },
    { serial: "Booking 2", date: "Jan 11,2024" },
    { serial: "Booking 3", date: "Jan 11,2024" },
    { serial: "Booking 4", date: "Jan 11,2024" },
  ];
  const handleFiltering = (value, filterType) => {
    // setFiltersBDF((prevFilters) => ({
    //   ...prevFilters,
    //   [filterType]: value,
    // }));
    setFiltersBDF((prevFilters) => {
      let updatedFilters = { ...prevFilters, [filterType]: value };

      // Ensure that both filters are not active at the same time
      if (filterType === "createdSO" && value) {
        updatedFilters.notConvertedSO = false;
      }
      if (filterType === "notConvertedSO" && value) {
        updatedFilters.createdSO = false;
      }

      return updatedFilters;
    });
  };

  const [dates, setDates] = useState(null);
  const handleDateChange = (dates, dateStrings) => {
    setDates(dates);
    setFiltersBDF((prevFilters) => ({
      ...prevFilters,
      dateRange: dateStrings.length > 0 ? dateStrings : null,
    }));
  };
  const handleClearFilters = () => {
    setDates(null);
    setFiltersBDF({
      client: null,
      createdBy: isElite ? null : userId,
      campaignName: null,
      dateRange: null,
      createdSO: false,
      notConvertedSO: false,
      stamp: null,
    });

    navigate(`/clients-bookings?tab=1`, { replace: true });
  };

  const filters = [
    {
      key: "showCreatedSO",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Converted to Sales Order</h6>
          <Switch
            checked={filtersBDF.createdSO || false}
            onChange={(checked) => handleFiltering(checked, "createdSO")}
            checkedChildren="Yes"
            unCheckedChildren="No"
          />
        </div>
      ),
    },
    {
      key: "showNotConvertedSO",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Not Converted to Sales Order</h6>
          <Switch
            checked={filtersBDF.notConvertedSO || false}
            onChange={(checked) => handleFiltering(checked, "notConvertedSO")}
            checkedChildren="Yes"
            unCheckedChildren="No"
          />
        </div>
      ),
    },
    // {
    //   key: "createdBy",
    //   label: (
    //     <div onClick={(e) => e.stopPropagation()}>
    //       <h6>Created By </h6>
    //       <Select
    //         showSearch
    //         allowClear
    //         value={filtersBDF.createdBy || undefined}
    //         style={{
    //           width: 200,
    //         }}
    //         placeholder="Client Name"
    //         optionFilterProp="label"
    //         filterSort={(optionA, optionB) =>
    //           (optionA?.label ?? "")
    //             .toLowerCase()
    //             .localeCompare((optionB?.label ?? "").toLowerCase())
    //         }
    //         options={createdOptions}
    //         onChange={(value) => handleFiltering(value, "createdBy")}
    //       />
    //     </div>
    //   ),
    // },
    {
      key: "client",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Client </h6>
          <Select
            showSearch
            allowClear
            value={
              clientOptions?.find((opt) => opt?.value === filtersBDF?.client)
                ? filtersBDF?.client
                : undefined
            }
            style={{
              width: 200,
            }}
            placeholder="Client Name  "
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={clientOptions}
            onChange={(value) => handleFiltering(value, "client")}
          />
        </div>
      ),
    },
    {
      key: "campaignName",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Campaign Name </h6>
          <Select
            showSearch
            allowClear
            value={filtersBDF.campaignName || undefined}
            style={{
              width: 200,
            }}
            placeholder="Campaign Names  "
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            options={campaignNames}
            onChange={(value) => handleFiltering(value, "campaignName")}
          />
        </div>
      ),
    },
    {
      key: "stamp",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Serial No.</h6>
          <Input
            type="text"
            value={filtersBDF.stamp ?? undefined}
            placeholder="Enter Serial Number"
            onChange={(e) => handleFiltering(e.target.value, "stamp")}
            style={{ width: 200 }}
          />
        </div>
      ),
    },
    {
      key: "dateRange",
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <h6>Booking Dates </h6>
          <RangePicker onChange={handleDateChange} value={dates} />
        </div>
      ),
    },
    {
      key: "clearFilters",
      label: (
        <Button
          onClick={(e) => handleClearFilters()}
          style={{ fontSize: "12px" }}
        >
          Clear
        </Button>
      ),
    },
  ];

  const detailedBookingsColumn = [
    {
      title: "Code",
      dataIndex: "CodeNo",
      key: "CodeNo",
    },
    {
      title: "Location",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
  ];

  const detailedBookingsData = [
    {
      CodeNo: "HK-076",
      area: "SG Road Palladium Mall LED",
      startDate: "24 March 2024",
      endDate: "29 March 2024",
    },
    {
      CodeNo: "HK-098",
      area: "Bopal - Ghuma Road - O/S The Retail Park Bopal Bridge towards Ghuma ",
      startDate: "12 March 2024",
      endDate: "18 March 2024",
    },
    {
      CodeNo: "HK-125",
      area: "Bopal - Ghuma Road - Opp. The Retail Park Ghuma Gam towards Bopal Bridge ",
      startDate: "5 March 2024",
      endDate: "10 March 2024",
    },
    {
      CodeNo: "HK-234",
      area: "Bopal - Ghuma Road - Opp. The Retail Park Ghuma Gam towards Bopal Bridge ",
      startDate: "8 March 2024",
      endDate: "15 March 2024",
    },
  ];

  function checkIfAcceptedExist(bdfdata) {
    return bdfdata?.BDFDetails?.some((ele) => ele.accepted) || false;
  }

  let dataClients2 = BDFData?.reduce((acc, ele, ind) => {
    if (checkIfAcceptedExist(ele)) {
      const clientInfo = {
        key: ind + 1,
        label: `Client: ${ele?.partyCompanyName}`,
        children: (
          <ClientInfo
            bookings={ele}
            bdfId={ele?._id}
            setFetched={setFetched}
            userId={userId}
            filtersBDF={filtersBDF}
          />
        ),
      };
      acc.push(clientInfo);
    }
    return acc;
  }, []);

  let dataClientsSub = subBDFData?.reduce((acc, ele, ind) => {
    if (checkIfAcceptedExist(ele)) {
      const clientInfo = {
        key: ind + 1,
        label: `Client: ${ele?.partyCompanyName}`,
        children: (
          <ClientInfo
            bookings={ele}
            bdfId={ele?._id}
            setFetched={setFetched}
            userId={userId}
            subBdfBool={true}
            filtersBDF={filtersBDF}
          />
        ),
      };
      acc.push(clientInfo);
    }
    return acc;
  }, []);

  const handleBookingClick = (key) => {
    navigate(`/clients-bdf/${key}`);
  };

  const handleViewBookings = () => {
    setBookingsModalOpen(true);
  };

  const handleItemClick = (item) => {
    dispatch(
      saveDraft({ inventories: item.inventories, bdfData: item.bdfData })
    );
    navigate(`/clients-bdf/${item._id}`);
  };
  const handleItemDelete = async (item) => {
    try {
      let requestBody = { id: item?._id };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteDraft`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (response.ok) {
        setDraftDeleted((prev) => !prev);
        notification.success({ message: "Draft is deleted successfully!" });
      }
      if (!responseJson.success) {
        notification.error({ message: responseJson?.message });
      }
    } catch (error) {
      console.log(`Error: ${error.message}`);
    }
  };
  const BookingsContent = () => {
    return (
      <div>
        {/* <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "end" }}>
      <AddNewClientComponent />
    </div> */}
        {dataClients2 && dataClients2.length > 0 ? (
          <Collapse items={dataClients2} accordion defaultActiveKey={["1"]} />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "2rem",
              fontWeight: "600",
              color: "gray",
            }}
          >
            <FaInbox /> No booked inventories yet!
          </div>
        )}
        <Modal
          title="Bookings"
          open={bookingsModalOpen}
          onCancel={() => {
            setBookingsModalOpen(false);
          }}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div className="bdfbased-booking-detail">
            <TableComponent
              dataSource={detailedBookingsData}
              columns={detailedBookingsColumn}
            />
          </div>
        </Modal>
      </div>
    );
  };
  const SubBDFContent = () => {
    return (
      <div>
        {/* <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "end" }}>
      <AddNewClientComponent />
    </div> */}
        {dataClientsSub && dataClientsSub.length > 0 ? (
          <Collapse items={dataClientsSub} accordion defaultActiveKey={["1"]} />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "2rem",
              fontWeight: "600",
              color: "gray",
            }}
          >
            <FaInbox /> No Sub BDF's created yet!
          </div>
        )}
        <Modal
          title="Bookings"
          open={bookingsModalOpen}
          onCancel={() => {
            setBookingsModalOpen(false);
          }}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div className="bdfbased-booking-detail">
            <TableComponent
              dataSource={detailedBookingsData}
              columns={detailedBookingsColumn}
            />
          </div>
        </Modal>
      </div>
    );
  };

  const DraftsContent = () => {
    return (
      <div>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <Spin />
          </div>
        ) : drafts?.length === 0 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              justifyContent: "center",
              fontSize: "1.4rem",
              fontWeight: "600",
              color: "gray",
            }}
          >
            <FaInbox /> No Drafts
          </div>
        ) : (
          <>
            <Collapse accordion>
              {drafts?.map((item) => (
                <Collapse.Panel
                  header={`${item.bdfData.campaignName} - ${moment(
                    item.createdAt
                  ).format("DD-MM-YYYY")}`}
                  key={item._id}
                  extra={
                    <div>
                      <Button onClick={() => handleItemClick(item)} type="link">
                        Edit
                      </Button>
                      <Popconfirm
                        placement="topRight"
                        title="Delete Draft"
                        description="Are you sure you wanna delete this draft ?"
                        onConfirm={() => handleItemDelete(item)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="link" style={{ color: "red" }}>
                          Delete
                        </Button>
                      </Popconfirm>
                    </div>
                  }
                >
                  <div className="bdf-info">
                    <p>Client: {item.bdfData.billingPartyName}</p>
                    <p>GST: {item.bdfData.gstNumber}</p>
                    <p>Campaign Duration: {item.bdfData.campaignDuration}</p>
                    <p>Total Inventories: {item.inventories.length}</p>
                  </div>
                  <div className="inventory-list">
                    <h3>Inventories</h3>
                    {item.inventories.map((inventory) => (
                      <div key={inventory._id} className="inventory-card">
                        <p>
                          <span className="label">Code No:</span>{" "}
                          <span className="main-value">{inventory.codeNo}</span>
                        </p>
                        <p>
                          <span className="label">Area:</span> {inventory.area}
                        </p>
                        <p>
                          <span className="label">Location:</span>{" "}
                          {inventory.location}
                        </p>
                        <p>
                          <span className="label">Media Vehicle:</span>{" "}
                          {inventory.mediaVehicle}
                        </p>
                        <p>
                          <span className="label">Rate Per Month:</span>{" "}
                          {inventory.ratePerMonth}
                        </p>
                        <p>
                          <span className="label">Mounting Charge:</span>{" "}
                          {inventory.mountingCharge}
                        </p>
                        <p>
                          <span className="label">Printing Charge:</span>{" "}
                          {inventory.printingCharge}
                        </p>
                        <p>
                          <span className="label">Special Rate:</span>{" "}
                          {inventory.specialRate}
                        </p>
                        <p>
                          <span className="label">Innovation Rate:</span>{" "}
                          {inventory.innovationRate}
                        </p>
                        <p>
                          <span className="label">Start Date:</span>{" "}
                          {inventory.startDate
                            ? moment(inventory.startDate).format("DD-MM-YYYY")
                            : "-"}
                        </p>
                        <p>
                          <span className="label">End Date:</span>{" "}
                          {inventory.endDate
                            ? moment(inventory.endDate).format("DD-MM-YYYY")
                            : "-"}
                        </p>
                      </div>
                    ))}
                  </div>
                </Collapse.Panel>
              ))}
            </Collapse>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={total}
              onChange={onPageChange}
              showSizeChanger
              pageSizeOptions={["10", "20", "50"]}
              style={{ marginTop: "1rem", textAlign: "center" }}
            />
          </>
        )}
      </div>
    );
  };

  if (!access) {
    return <AuthorizationError />;
  }
  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "0px 20px",
      }}
    >
      <div
        style={{
          // backgroundColor: "white",
          padding: "0px 20px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={tabChange}
          items={tabs}
        />
        {(activeTab == 1 || activeTab == 2 || activeTab == 3) && (
          <Dropdown
            menu={{
              items: filters,
            }}
            placement="bottomRight"
            arrow
            trigger={["click"]}
          >
            <Button>
              <FaFilter />
            </Button>
          </Dropdown>
        )}
      </div>
      {renderTabContent()}
    </div>
  );
};

export default BookingInfoContainer;

const ClientInfo = ({
  bookings,
  bdfId,
  setFetched,
  userId,
  subBdfBool,
  filtersBDF,
}) => {
  const user = useSelector((state) => state.user);
  const [inventories, setInventories] = useState(null);
  const [subBDFId, setSubBDFId] = useState(null);
  const [bookingsModalOpen, setBookingsModalOpen] = useState(false);
  const [subBDFModalOpen, setSubBDFModalOpen] = useState(false);
  const [detailedBookingsData, setDetailedBookingsData] = useState(null);
  const [suffixBookingsData, setSuffixBookingsData] = useState(null);
  const [detailedBookingsDataSub, setDetailedBookingsDataSub] = useState(null);
  const [packageRate, setPackageRate] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalVisibleEmail, setModalVisibleEmail] = useState(false);
  const [sendBdfEmailLoading, setSendBdfEmailLoading] = useState(false);
  const sendBdfEmailInFlightRef = useRef(false);
  const emailAttachmentInputRef = useRef(null);
  const [bodyOfEmail, setBodyOfEmail] = useState("");
  const [emailAttachments, setEmailAttachments] = useState([]);
  const [emailAttachmentUploading, setEmailAttachmentUploading] = useState(false);
  const [brandName, setBrandName] = useState("");
  const [bdfDate, setBdfDate] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [partyMasterOptions, setPartyMasterOptions] = useState([]);
  const [brandsForParty, setBrandsForParty] = useState([]);
  const [subBdfParentCompanyId, setSubBdfParentCompanyId] = useState(null);
  const [subBdfBrandId, setSubBdfBrandId] = useState(null);
  const [brandsLoading, setBrandsLoading] = useState(false);
  const [printingZeroedSnapshot, setPrintingZeroedSnapshot] = useState(null);
  const [mountingZeroedSnapshot, setMountingZeroedSnapshot] = useState(null);
  const [subBdfEditModalOpen, setSubBdfEditModalOpen] = useState(false);
  const [subBdfEditSaving, setSubBdfEditSaving] = useState(false);
  const [subBdfEditId, setSubBdfEditId] = useState(null);
  const [subBdfEditInventories, setSubBdfEditInventories] = useState([]);
  const [subBdfEditBdfDate, setSubBdfEditBdfDate] = useState(null);
  const [subBdfSaving, setSubBdfSaving] = useState(false);
  const [subBdfRoFile, setSubBdfRoFile] = useState(null);
  const [subBdfRoUploading, setSubBdfRoUploading] = useState(false);
  const [parentInventoryPool, setParentInventoryPool] = useState([]);
  const [subBdfEditRoFile, setSubBdfEditRoFile] = useState(null);
  const [subBdfEditRoUploading, setSubBdfEditRoUploading] = useState(false);
  const [subBdfEditParentPool, setSubBdfEditParentPool] = useState([]);
  const [subBdfEditCampaignName, setSubBdfEditCampaignName] = useState("");
  const [subBdfEditParentCompanyId, setSubBdfEditParentCompanyId] =
    useState(null);
  const [subBdfEditBrandId, setSubBdfEditBrandId] = useState(null);
  const [subBdfEditNewBrandName, setSubBdfEditNewBrandName] = useState("");
  const [subBdfEditBrandSearch, setSubBdfEditBrandSearch] = useState("");
  const [subBdfInvPickerOpen, setSubBdfInvPickerOpen] = useState(false);
  const [subBdfInvPickerTarget, setSubBdfInvPickerTarget] = useState("create");
  const [subBdfPickerInvs, setSubBdfPickerInvs] = useState([]);
  const [subBdfPickerInvsD, setSubBdfPickerInvsD] = useState([]);
  const [subBdfPickerSearch, setSubBdfPickerSearch] = useState("");
  const [subBdfInvPickerToggle, setSubBdfInvPickerToggle] = useState(false);

  const reduxInvs = useSelector((state) => state.inventoriesList.inventories);

  const openRoFileInNewTab = (url) => {
    if (!url) return;
    openFileInNewTab(url);
  };

  const mapReduxInvToSubBdfLine = (ele, parentPool = []) => {
    const fromParent = parentPool.find((p) => p._id === ele._id);
    if (fromParent) return { ...fromParent };

    const width = ele.width;
    const height = ele.height;
    const illu = ele.Illu;
    const unit = ele?.unit;
    const mediaName = ele?.typeOfMedia?.name ?? ele?.typeOfMedia;

    return {
      _id: ele._id,
      code: ele.code ?? ele.codeNo ?? ele.CodeNo ?? "",
      location: ele.location ?? ele?.locations?.name ?? "",
      width,
      height,
      mountingCharge:
        ele.mountingCharge != null
          ? Number(ele.mountingCharge)
          : generateMC(width, height, illu, unit, mediaName),
      printingCharge:
        ele.printingCharge != null
          ? Number(ele.printingCharge)
          : generatePC(width, height, illu, unit, mediaName),
      specialRate: Number(ele?.specialRate) || 0,
      innovationRate: Number(ele?.innovationRate) || 0,
      ratePerMonth: ele.ratePerMonth ?? ele.rpm ?? 0,
      startDate: ele.startDate ?? null,
      endDate: ele.endDate ?? null,
    };
  };

  const mapInventoryLineForSubBdf = (ele) => {
    const invId = ele?.invId || ele;
    const id = invId?._id || ele?._id;
    const width = invId?.width ?? ele?.width;
    const height = invId?.height ?? ele?.height;
    const illu = invId?.Illu;
    const unit = invId?.unit;
    const mediaName = invId?.typeOfMedia?.name;
    return {
      _id: id,
      code: invId?.CodeNo || ele?.codeNo,
      location: invId?.locations?.name || ele?.location,
      width,
      height,
      mountingCharge:
        ele?.mountingCharge != null
          ? Number(ele.mountingCharge)
          : generateMC(width, height, illu, unit, mediaName),
      printingCharge:
        ele?.printingCharge != null
          ? Number(ele.printingCharge)
          : generatePC(width, height, illu, unit, mediaName),
      specialRate: Number(ele?.specialRate) || 0,
      innovationRate: Number(ele?.innovationRate) || 0,
      ratePerMonth: ele?.rpm ?? ele?.ratePerMonth ?? invId?.ratePerMonth ?? 0,
      startDate: ele?.startDate,
      endDate: ele?.endDate,
    };
  };

  const uploadRoFileToS3 = async (file) => {
    const response = await fetch(`${apiBaseUrl}/inventoryManagement/uploadPolicy`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mime: file.type,
        fileName: file.name,
      }),
    });

    const { data: policyData, filePath } = await response.json();
    if (!response.ok || !policyData?.url) {
      throw new Error("Failed to get upload policy");
    }

    const uploadUrl = `${policyData.url}/${filePath}`;
    const formData = new FormData();
    Object.entries(policyData.fields).forEach(([key, value]) => {
      if (key.toLowerCase() === "content-type") {
        formData.append(key, file.type || "application/octet-stream");
        return;
      }
      formData.append(key, value);
    });
    formData.append("file", file);

    const s3Response = await fetch(policyData.url, {
      method: "POST",
      body: formData,
    });

    if (!s3Response.ok) {
      throw new Error("S3 upload failed");
    }

    return convertS3ToCloudFront(uploadUrl);
  };

  const handleSubBdfRoFileSelect = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    try {
      setSubBdfRoUploading(true);
      const uploadUrl = await uploadRoFileToS3(file);
      setSubBdfRoFile(uploadUrl);
      notification.success({ message: "RO file uploaded" });
    } catch (error) {
      notification.error({
        message: error?.message || "Failed to upload RO file",
      });
    } finally {
      setSubBdfRoUploading(false);
    }
  };

  const handleSubBdfEditRoFileSelect = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    try {
      setSubBdfEditRoUploading(true);
      const uploadUrl = await uploadRoFileToS3(file);
      setSubBdfEditRoFile(uploadUrl);
      notification.success({ message: "RO file uploaded" });
    } catch (error) {
      notification.error({
        message: error?.message || "Failed to upload RO file",
      });
    } finally {
      setSubBdfEditRoUploading(false);
    }
  };

  const handleEmailAttachmentSelect = async (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    if (!files.length) return;

    const maxBytes = 10 * 1024 * 1024;
    setEmailAttachmentUploading(true);
    try {
      const uploaded = [];
      for (const file of files) {
        if (file.size > maxBytes) {
          notification.error({ message: `${file.name} is larger than 10 MB` });
          continue;
        }
        const url = await uploadRoFileToS3(file);
        uploaded.push({
          name: file.name,
          url,
          mime: file.type || "application/octet-stream",
        });
      }
      if (uploaded.length) {
        setEmailAttachments((prev) => [...prev, ...uploaded].slice(0, 10));
      }
    } catch (error) {
      notification.error({
        message: error?.message || "Failed to upload attachment",
      });
    } finally {
      setEmailAttachmentUploading(false);
    }
  };

  const modules = {
    toolbar: [["bold", "italic", "underline", "link"]],
  };

  const formats = ["bold", "italic", "underline", "link"];
  const [emailBdfId, setEmailBdfId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/getPartyMasterReport`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const result = await response.json();
        if (!cancelled && result.success && Array.isArray(result.parties)) {
          setPartyMasterOptions(result.parties);
        }
      } catch (e) {
        console.error("Error fetching party master:", e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const fetchBrandsForParty = async (partyId) => {
    if (!partyId) {
      setBrandsForParty([]);
      return;
    }
    setBrandsLoading(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getBrandsByPartyId?partyCompany=${partyId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (result.success && Array.isArray(result.data)) {
        setBrandsForParty(result.data);
      } else {
        setBrandsForParty([]);
      }
    } catch (e) {
      console.error("Error fetching brands:", e);
      setBrandsForParty([]);
    } finally {
      setBrandsLoading(false);
    }
  };

  const toEntityId = (value) => {
    if (!value) return null;
    if (typeof value === "string") return value;
    if (typeof value === "object" && value._id) return String(value._id);
    return null;
  };

  const resetSubBdfOptionalFields = () => {
    setCampaignName("");
    setSubBdfParentCompanyId(null);
    setSubBdfBrandId(null);
    setBrandsForParty([]);
    setSubBdfRoFile(null);
    setParentInventoryPool([]);
  };

  const resetSubBdfEditFields = () => {
    setSubBdfEditId(null);
    setSubBdfEditInventories([]);
    setSubBdfEditBdfDate(null);
    setSubBdfEditRoFile(null);
    setSubBdfEditParentPool([]);
    setSubBdfEditCampaignName("");
    setSubBdfEditParentCompanyId(null);
    setSubBdfEditBrandId(null);
    setSubBdfEditNewBrandName("");
    setSubBdfEditBrandSearch("");
    setBrandsForParty([]);
  };

  const handleSubBdfEditRemoveInventory = (id) => {
    setSubBdfEditInventories((prev) => prev.filter((item) => item._id !== id));
  };

  const getSubBdfCurrentInventoryIds = (target = subBdfInvPickerTarget) => {
    const list =
      target === "edit" ? subBdfEditInventories : inventories;
    return new Set((list || []).map((item) => item._id).filter(Boolean));
  };

  const openSubBdfInvPicker = (target) => {
    setSubBdfInvPickerTarget(target);
    setSubBdfPickerSearch("");
    dispatch(getInventories());
    setSubBdfInvPickerToggle((prev) => !prev);
    setSubBdfInvPickerOpen(true);
  };

  const closeSubBdfInvPicker = () => {
    setSubBdfInvPickerOpen(false);
    setSubBdfPickerInvs([]);
    setSubBdfPickerInvsD([]);
    setSubBdfPickerSearch("");
  };

  const handleSubBdfPickerCheckbox = (e, record) => {
    const { checked } = e.target;
    const updatedData = subBdfPickerInvsD.map((item) =>
      item._id === record._id ? { ...item, checked } : item,
    );
    setSubBdfPickerInvsD(updatedData);
    setSubBdfPickerInvs(filterSearch(subBdfPickerSearch, updatedData));
  };

  const handleSubBdfPickerSearch = (e) => {
    const value = e.target.value;
    setSubBdfPickerSearch(value);
    setSubBdfPickerInvs(filterSearch(value, subBdfPickerInvsD));
  };

  const confirmSubBdfInvPicker = () => {
    const selected = (subBdfPickerInvsD || []).filter((item) => item.checked);
    if (selected.length === 0) {
      notification.warning({ message: "Please select at least one inventory." });
      return;
    }

    const parentPool =
      subBdfInvPickerTarget === "edit"
        ? subBdfEditParentPool
        : parentInventoryPool;
    const mapped = selected.map((item) => {
      const reduxItem = reduxInvs?.find((inv) => inv._id === item._id);
      return mapReduxInvToSubBdfLine(reduxItem || item, parentPool);
    });

    if (subBdfInvPickerTarget === "edit") {
      setSubBdfEditInventories((prev) => {
        const existing = new Set((prev || []).map((row) => row._id));
        return [
          ...(prev || []),
          ...mapped.filter((row) => !existing.has(row._id)),
        ];
      });
    } else {
      setInventories((prev) => {
        const existing = new Set((prev || []).map((row) => row._id));
        return [
          ...(prev || []),
          ...mapped.filter((row) => !existing.has(row._id)),
        ];
      });
    }

    closeSubBdfInvPicker();
    notification.success({
      message: `${mapped.length} inventor${mapped.length === 1 ? "y" : "ies"} added`,
    });
  };

  useEffect(() => {
    if (!subBdfInvPickerOpen || !Array.isArray(reduxInvs)) return;

    const currentIds = getSubBdfCurrentInventoryIds(subBdfInvPickerTarget);
    const pickerData = reduxInvs
      .filter((item) => item?._id && !currentIds.has(item._id))
      .map((ele) => ({
        _id: ele._id,
        codeNo: ele.CodeNo,
        location: ele?.locations?.name,
        width: ele.width,
        height: ele.height,
        Illu: ele.Illu,
        unit: ele?.unit || 1,
        typeOfMedia: ele?.typeOfMedia,
        ratePerMonth: ele.ratePerMonth,
        checked: false,
      }));

    setSubBdfPickerInvs(pickerData);
    setSubBdfPickerInvsD(pickerData);
  }, [
    subBdfInvPickerOpen,
    subBdfInvPickerToggle,
    subBdfInvPickerTarget,
    reduxInvs,
    inventories,
    subBdfEditInventories,
  ]);

  const renderSubBdfRoSection = ({
    roFile,
    uploading,
    inputId,
    onFileSelect,
    hideLabel = false,
  }) => (
    <div className="sub-bdf-field-group">
      {!hideLabel && (
        <label className="sub-bdf-label">
          RO File
          <span className="sub-bdf-optional-tag">(Optional)</span>
        </label>
      )}
      {roFile ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            padding: "12px 14px",
            background: "#f6ffed",
            border: "1px solid #b7eb8f",
            borderRadius: 8,
          }}
        >
          <span style={{ color: "#52c41a", fontWeight: 600 }}>
            RO file attached
          </span>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => openRoFileInNewTab(roFile)}
            >
              View RO
            </Button>
            <Button
              loading={uploading}
              onClick={() => document.getElementById(inputId)?.click()}
            >
              Change RO File
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <p className="sub-bdf-field-hint">
            Upload RO confirmation for this Sub BDF. Parent BDF RO is used when
            left empty on create.
          </p>
          <Button
            type="primary"
            loading={uploading}
            onClick={() => document.getElementById(inputId)?.click()}
          >
            Upload RO File
          </Button>
        </div>
      )}
      <input
        type="file"
        id={inputId}
        accept=".pdf,.jpg,.jpeg,.png"
        style={{ display: "none" }}
        onChange={onFileSelect}
      />
    </div>
  );

  // Function to handle modal visibility
  const handleOpenModal = async (
    record,
    downloadBDF = false,
    isSubBDF = false
  ) => {
    let logs, isRevisedBDF, secondLastLog, bdfLink;

    logs = await fetchBdfLogs(record?.bdfDetails?._id);

    isRevisedBDF = logs && Array.isArray(logs) && logs.length >= 2;
    secondLastLog =
      logs.length > 1 ? logs[logs.length - 2] : logs[logs.length - 1] || {};

    if (isSubBDF) {
      bdfLink = await getSubBDFLink(
        record?.inventories,
        record?.bdfDetails,
        downloadBDF,
        secondLastLog
      );
    } else {
      bdfLink = await getBDFLink(
        record?.inventories,
        record?.bdfDetails,
        downloadBDF,
        secondLastLog,
        record?.suffixInventories
      );
    }
    setEmailBdfId(record._id);
    setEmailAttachments([]);

    setModalVisibleEmail(true);
    setBodyOfEmail(`
      <br/>
      <p>Dear Team,</p>
      <br/>
      <br/>
      <p>${
        isSubBDF
          ? `Please find the attached production Sub-BDF for ${record?.bdfDetails?.brandId?.brandName}.`
          : `Please find the attached BDF for ${record?.bdfDetails?.brandId?.brandName} for ${record?.bdfDetails?.campaignDuration} days.`
      }
      <br/>
      <br/>
      <p><a href="${encodeURI(bdfLink)}">BDF Link</a></p>
      <br/>
      ${
        record?.bdfDetails?.roFile
          ? `<p><a href="${getViewableFileUrl(record.bdfDetails.roFile)}">RO Link</a></p><br/>`
          : ""
      }
      <br/>
      <br/>
      <p>Thanks &amp; Regards,</p>
      <br/>
      <p>${user?.name || ""}</p>
      <br/>
  </p>`);

    setBrandName(
      isRevisedBDF
        ? `${isSubBDF ? "Revised Sub BDF" : "Revised BDF"} - ${
            record?.bdfDetails?.brandId?.brandName
          } - ${moment().format("DD/MM/YYYY hh:mm:ss A")}`
        : `${record?.bdfDetails?.brandId?.brandName} - ${moment().format(
            "DD/MM/YYYY hh:mm:ss A"
          )}`
    );
  };

  function getBDFLink(
    inventories,
    bdfDetails,
    downloadBDF,
    secondLastLog,
    suffixInventories
  ) {
    const bdfUrl = createBDFExcelChanges(
      bdfDetails,
      inventories,
      "",
      downloadBDF,
      secondLastLog,
      suffixInventories
    );
    return bdfUrl;
  }

  function getSubBDFLink(inventories, bdfDetails, downloadBDF, secondLastLog) {
    return createBDFExcelChanges(
      bdfDetails,
      inventories,
      "",
      downloadBDF,
      secondLastLog,
      [],
      true
    );
  }

  const handleCancelEmail = () => {
    if (sendBdfEmailLoading) return;
    setModalVisibleEmail(false);
    setBodyOfEmail("");
    setEmailBdfId(null);
    setEmailAttachments([]);
  };

  // Function to handle text area changes
  const handleTextArea = (value) => {
    setBodyOfEmail(value);
  };

  const handleEditBDF = (id) => {
    dispatch(emptyDraft());

    const searchParams = new URLSearchParams();

    Object.entries(filtersBDF).forEach(([key, value]) => {
      if (value) {
        if (key === "dateRange" && value.length === 2) {
          searchParams.set("startDate", encodeURIComponent(value[0]));
          searchParams.set("endDate", encodeURIComponent(value[1]));
        } else {
          searchParams.set(key, value);
        }
      }
    });
    navigate(`/clients-bdf-edit/${id}?${searchParams.toString()}`);
  };

  const handleDeleteBDF = async (id) => {
    try {
      let requestBody = {
        bdfId: id,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteCBdf`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      }
      if (responseJson.success) {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
      }
    } catch (err) {
      console.error("Error: ", err.message);
    }
  };
  const handleDeleteSubBDF = async (id) => {
    try {
      let requestBody = {
        id,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteSubBdf`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      }
      if (responseJson.success) {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
      }
    } catch (err) {
      console.error("Error: ", err.message);
    }
  };

  const handleArchiveBDF = async (id) => {
    try {
      let requestBody = {
        bdfId: id,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/archiveCBdf`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      }
      if (responseJson.success) {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
      }
    } catch (err) {
      console.error("Error: ", err.message);
    }
  };

  /**
   * Open Premium Block create screen from BDF (mirror of Premium → BDF).
   * Prefills party/campaign/inventories (amounts zeroed). bdfId is passed in
   * navigation state so createPremiumBlock can archive the BDF on submit.
   */
  const handleCreatePremiumFromBdf = (record) => {
    const details = record?.bdfDetails || {};
    const bdfId = details?._id || record?._id;
    if (!bdfId) {
      notification.error({ message: "BDF id missing" });
      return;
    }
    if (details?.createdSO) {
      notification.error({
        message:
          "Cannot create Premium Block: Sales Order already exists. Archiving is not allowed.",
      });
      return;
    }
    if (details?.isLocked) {
      notification.error({
        message:
          "Cannot create Premium Block: BDF is locked because a bill has been generated.",
      });
      return;
    }

    const sourceInventories = (record?.inventories || []).filter(
      (item) =>
        !item?.suffixCode &&
        !["AGENCY_COMMISSION", "TRANSPORTATION"].includes(item?.lineType) &&
        (item?.invId?._id || item?.invId)
    );

    if (!sourceInventories.length) {
      notification.error({
        message: "This BDF has no inventories to convert to Premium Block",
      });
      return;
    }

    const missingDates = sourceInventories.filter(
      (item) => !item?.startDate || !item?.endDate
    );
    if (missingDates.length > 0) {
      notification.error({
        message:
          "All inventories must have start and end dates before creating Premium Block",
      });
      return;
    }

    const partyId =
      typeof details?.parentCompanyId === "object"
        ? details?.parentCompanyId?._id
        : details?.parentCompanyId;
    const partyName =
      details?.parentCompanyName ||
      details?.billingPartyName ||
      details?.brandId?.partyName;

    if (!partyId && !partyName) {
      notification.error({
        message: "Party company is required to create Premium Block",
      });
      return;
    }

    const inventories = sourceInventories.map((item) => {
      const inv = item?.invId || {};
      const invId = inv?._id || item?.invId;
      const fromRedux = (reduxInvs || []).find(
        (r) => String(r?._id) === String(invId)
      );

      // Exclude source BDF bookings so its dates stay selectable on Premium form
      const bookingsFiltered = (
        inv?.Bookings ||
        fromRedux?.Bookings ||
        []
      ).filter(
        (b) => String(b?.bdfId?._id || b?.bdfId) !== String(bdfId)
      );

      return {
        _id: invId,
        codeNo: inv?.CodeNo ?? fromRedux?.CodeNo,
        location: inv?.locations?.name ?? fromRedux?.locations?.name,
        width: inv?.width ?? fromRedux?.width,
        height: inv?.height ?? fromRedux?.height,
        Illu: inv?.Illu ?? fromRedux?.Illu,
        unit: inv?.unit ?? fromRedux?.unit ?? 1,
        Bookings: bookingsFiltered,
        premiumBlock: inv?.premiumBlock || fromRedux?.premiumBlock || [],
        blockedDates: inv?.blockedDates || fromRedux?.blockedDates || [],
        isOverlapPossible:
          inv?.isOverlapPossible ?? fromRedux?.isOverlapPossible,
        // Premium hides amounts — always prefill zeros
        printingCharge: 0,
        mountingCharge: 0,
        specialRate: 0,
        specialRatePerMonth: 0,
        innovationRate: 0,
        rpm: 0,
        ratePerMonth: 0,
        startDate: item?.startDate
          ? dayjs(item.startDate).isValid()
            ? dayjs(item.startDate).format("DD-MM-YYYY")
            : item.startDate
          : null,
        endDate: item?.endDate
          ? dayjs(item.endDate).isValid()
            ? dayjs(item.endDate).format("DD-MM-YYYY")
            : item.endDate
          : null,
      };
    });

    const data = {
      blockedForId: partyId || null,
      blockedForName: partyName || null,
      inventories,
      confirmedBy: details?.approvedBy || "From BDF",
      campaignName: details?.campaignName
        ? String(details.campaignName).trim().toUpperCase()
        : "",
      fromBdf: true,
      bdfId: String(bdfId),
    };

    dispatch(emptyBlockInventories());
    dispatch(addBlockInventories(data));
    navigate("/premiumBlock/create", {
      state: { bdfId: String(bdfId) },
    });
  };

  const handleEdit = (value, id, field) => {
    value = value.replace(/\D/g, "");
    setInventories((prev) => {
      const index = prev.findIndex((item) => item._id === id);
      const updatedInventories = [...prev];
      updatedInventories[index] = {
        ...updatedInventories[index],
        [field]: Number(value),
      };
      return updatedInventories;
    });
  };

  const handleRemoveInventory = (id) => {
    setInventories((prev) => prev.filter((item) => item._id !== id));
  };
  // function handleViewBookings(invs, PRate) {
  //   setPackageRate(null);
  //   let data = invs?.map((ele) => {
  //     console.log("ele",ele)

  //     return {
  //       CodeNo: ele?.invId?.CodeNo,
  //       area: ele?.invId?.locations?.name,
  //       mountingCharge: ele?.mountingCharge,
  //       printingCharge: ele?.printingCharge,
  //       specialRate: ele?.specialRate,
  //       startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
  //       endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
  //     };
  //   });
  //   setDetailedBookingsData(data);
  //   setPackageRate(PRate);
  //   setBookingsModalOpen(true);
  // }
  function handleViewBookings(invs, PRate, suffixInventories) {
    setPackageRate(null);
    let data = invs
      ?.filter((ele) => !ele?.suffixCode)
      .map((ele) => {
        if (ele?.invId?.isTrading === false) {
          return {
            CodeNo: (
              <>
                {ele?.invId?.CodeNo}
                <img
                  src={yellowSpotLogo}
                  alt=""
                  style={{
                    marginLeft: "5px",
                    position: "absolute",
                    top: "30px",
                    left: "-6px",
                    width: "18px",
                  }}
                />
              </>
            ),
            area: ele?.invId?.locations?.name,
            mountingCharge: ele?.mountingCharge,
            printingCharge: ele?.printingCharge,
            specialRate: ele?.specialRate,
            startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
            endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
            // isTrading: ele?.invId?.isTrading,
          };
        }

        // Otherwise, include all other details
        return {
          CodeNo: ele?.invId?.CodeNo,
          area: ele?.invId?.locations?.name,
          mountingCharge: ele?.mountingCharge,
          printingCharge: ele?.printingCharge,
          specialRate: ele?.specialRate,
          startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
          endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
          // isTrading: ele?.invId?.isTrading
        };
      });

    let suffixData = suffixInventories?.map((suffix, index) => ({
      key: index,
      suffixCode: suffix.suffixCode,
      vendor: suffix.vendor,
      suffixInfo: suffix.suffixInfo,
      specialRate: suffix.specialRate,
    }));

    setDetailedBookingsData(data);
    setSuffixBookingsData(suffixData);
    setPackageRate(PRate);
    setBookingsModalOpen(true);
  }

  const parseBdfDateValue = (value) => {
    if (!value) return null;
    const strict = moment(value, "DD-MM-YYYY", true);
    if (strict.isValid()) return dayjs(strict.toDate());
    const fallback = dayjs(value);
    return fallback.isValid() ? fallback : null;
  };

  const openSubBdfEditModal = async (record) => {
    const details = record?.bdfDetails || {};
    const subId = record?._id || details?._id || null;
    const partyId = toEntityId(details?.parentCompanyId);
    const brandId = toEntityId(details?.brandId);

    setSubBdfEditId(subId);
    setSubBdfEditBdfDate(parseBdfDateValue(details?.bdfDate));
    setSubBdfEditRoFile(details?.roFile || null);
    setSubBdfEditParentPool([]);
    setSubBdfEditCampaignName(
      details?.campaignName ? String(details.campaignName).toUpperCase() : ""
    );
    setSubBdfEditParentCompanyId(partyId);
    setSubBdfEditBrandId(brandId);
    setSubBdfEditNewBrandName("");
    setSubBdfEditBrandSearch("");
    setBrandsForParty([]);

    const rows =
      record?.inventories
        ?.filter((ele) => !ele?.suffixCode && !ele?.lineType)
        ?.map((ele) => mapInventoryLineForSubBdf(ele)) || [];

    setSubBdfEditInventories(rows);
    setSubBdfEditModalOpen(true);

    if (partyId) {
      fetchBrandsForParty(partyId);
    }

    const parentBdfId = toEntityId(details?.bdfId) || details?.bdfId;
    if (!parentBdfId) return;

    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getBdfDataById?id=${parentBdfId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const responseData = await response.json();
      if (response.ok && responseData?.success) {
        const pool = (responseData?.data?.inventories || [])
          .filter((ele) => !ele?.suffixCode)
          .map((ele) => mapInventoryLineForSubBdf(ele));
        setSubBdfEditParentPool(pool);
      }
    } catch (error) {
      console.error("Error fetching parent BDF inventories:", error);
    }
  };

  const handleSubBdfEditField = (value, id, field) => {
    const clean = String(value ?? "").replace(/\D/g, "");
    setSubBdfEditInventories((prev) => {
      const next = Array.isArray(prev) ? [...prev] : [];
      const idx = next.findIndex((r) => r._id === id);
      if (idx === -1) return next;
      next[idx] = {
        ...next[idx],
        [field]: Number(clean || 0),
      };
      return next;
    });
  };

  const saveSubBdfEdits = async () => {
    if (!subBdfEditId) return;

    // Treat text typed in the Brand box (not yet picked) as the chosen brand
    const pendingTyped = subBdfEditBrandSearch.trim().toUpperCase();
    const typedMatch = pendingTyped
      ? brandsForParty.find(
          (b) => (b.brandName || "").trim().toUpperCase() === pendingTyped
        )
      : null;
    const effectiveBrandId = subBdfEditBrandId || typedMatch?._id || null;
    const effectiveNewBrandName = effectiveBrandId
      ? ""
      : (pendingTyped || subBdfEditNewBrandName).trim().toUpperCase();

    if (
      subBdfEditParentCompanyId &&
      !effectiveBrandId &&
      !effectiveNewBrandName
    ) {
      notification.error({
        message:
          "Please select or type a brand for the selected party company before saving",
      });
      return;
    }

    setSubBdfEditSaving(true);
    try {
      const trimmedCampaign = subBdfEditCampaignName?.trim().toUpperCase();
      const payload = {
        subBDFId: subBdfEditId,
        bdfDate: subBdfEditBdfDate
          ? dayjs(subBdfEditBdfDate).format("DD-MM-YYYY")
          : null,
        inventories: (subBdfEditInventories || [])
          .filter((row) => row?._id)
          .map((row) => ({
            _id: row._id,
            printingCharge: Number(row.printingCharge) || 0,
            mountingCharge: Number(row.mountingCharge) || 0,
            specialRate: Number(row.specialRate) || 0,
            innovationRate: Number(row.innovationRate) || 0,
            ratePerMonth: Number(row.ratePerMonth) || 0,
            startDate: row.startDate,
            endDate: row.endDate,
          })),
      };
      if (subBdfEditRoFile) {
        payload.roFile = subBdfEditRoFile;
      }
      if (trimmedCampaign) {
        payload.campaignName = trimmedCampaign;
      }
      if (subBdfEditParentCompanyId) {
        payload.parentCompanyId = subBdfEditParentCompanyId;
      }
      if (effectiveBrandId) {
        payload.brandId = effectiveBrandId;
      } else if (effectiveNewBrandName) {
        payload.brandName = effectiveNewBrandName;
      }

      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/updateSubBDF`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const responseData = await response.json();
      if (response.ok && responseData?.success) {
        notification.success({
          message: responseData?.message || "Sub-BDF updated successfully",
        });
        setSubBdfEditModalOpen(false);
        resetSubBdfEditFields();
        setFetched((prev) => !prev);
      } else {
        notification.error({
          message: responseData?.message || "Failed to update Sub-BDF",
        });
      }
    } catch (error) {
      notification.error({
        message: error?.message || "Failed to update Sub-BDF",
      });
    } finally {
      setSubBdfEditSaving(false);
    }
  };

  function handleBookingClick(
    inventories,
    bdfDetails,
    suffixInventories,
    secondLastLog
  ) {
    // console.log("Inventries:", inventories)
    // console.log("bdfDetails:", bdfDetails)

    // createBDFExcel(bdfDetails, inventories);
    createBDFExcelChanges(
      bdfDetails,
      inventories,
      "",
      "",
      secondLastLog,
      suffixInventories
    );
  }

  function handleSubBookingClick(
    inventories,
    bdfDetails,
    downloadBDF,
    secondLastLog
  ) {
    createBDFExcelChanges(
      bdfDetails,
      inventories,
      "",
      downloadBDF,
      secondLastLog,
      [],
      true
    );
  }

  const handleOkEmail = async () => {
    if (sendBdfEmailInFlightRef.current) return;
    sendBdfEmailInFlightRef.current = true;
    setSendBdfEmailLoading(true);
    try {
      let emailFrom = "sales@yellowspot.in";

      if (userId === "6655da0d21d3e92d1b400e27") {
        emailFrom = "sales@yellowspot.in";
      } else if (userId === "6655d9b40777525410c88982") {
        emailFrom = "aksha.shah@yellowspot.in";
      } else if (userId === "6655da0db7fa235637d8803a") {
        emailFrom = "mediaplanning@yellowspot.in";
      } else if (userId === "668bb8a8dc1b17763bfc16bd") {
        emailFrom = "pankaj.vyas@yellowspot.in";
      } else if (userId === "668bb8a98846df09d6649fc3") {
        emailFrom = "meet.javia@yellowspot.in";
      } else if (userId === "668bb8a86a5e8031326ead83") {
        emailFrom = "saurabh.sharma@yellowspot.in";
      } else if (userId === "6655da3e6826d0540967b9ce") {
        emailFrom = "Sagar Panchal <sales@yellowspot.in>";
      } else if (userId === "673720baba31e17dc04e3c4f") {
        // emailFrom = "dimple.pandya@khushiadvertising.com";
        emailFrom = "Dimple Pandya <sales@yellowspot.in>";
      } else if (userId === "68636e2a8e9cb38030bb14f7") {
        emailFrom = "nirav.patel@yellowspot.in"; 
      } else if (userId === "6902fc2b4ef0a3fac1749d29") {
        emailFrom = "Mansi Shah <sales@yellowspot.in>"; 
      }

      // else if (userId === "6655da3e6826d0540967b9ce") {
      //   emailFrom = "sagar.panchal@khushiadvertising.com";
      // } else if (userId === "673720baba31e17dc04e3c4f") {
      //   emailFrom = "dimple.pandya@khushiadvertising.com";
      // }

      const emailSubject = brandName;

      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/sendBDFMail`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailBody: bodyOfEmail,
            emailFrom: emailFrom,
            emailSubject: emailSubject,
            id: emailBdfId,
            attachments: emailAttachments.map((file) => ({
              fileName: file.name,
              url: file.url,
              mime: file.mime,
            })),
          }),
        }
      );

      const responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      } else {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
        setModalVisibleEmail(false);
        setBodyOfEmail("");
        setEmailBdfId(null);
        setEmailAttachments([]);
      }
    } catch (err) {
      console.error("Error:", err.message);
      notification.error({ message: "Failed to send email." });
    } finally {
      sendBdfEmailInFlightRef.current = false;
      setSendBdfEmailLoading(false);
    }
  };

  const fetchBdfLogs = async (bdfId) => {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getBdfLogsById?bdfId=${bdfId}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        return responseData?.data?.logs || [];
      } else {
        notification.error({
          message: responseData?.message || "Failed to fetch BDF logs by ID",
        });
        return [];
      }
    } catch (error) {
      notification.error({
        message: "Error occurred while fetching BDF logs by ID",
      });
      return [];
    }
  };

  const columnBookings = [
    {
      title: "Send to SO",
      dataIndex: "select",
      key: "select",
      render: (_, record) => {
        return (
          <Checkbox
            onChange={() => handleCheckboxChange(record)}
            checked={
              record.bdfDetails.createdSO ||
              selectedRows.includes(record.bdfDetails._id)
            }
            disabled={record.bdfDetails.createdSO}
            className={
              record.bdfDetails.createdSO ? "custom-disabled-checkbox" : ""
            }
          />
        );
      },
    },
    {
      title: "Serial No.",
      dataIndex: "serial",
      key: "serial",
    },
    {
      title: "Booked On",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Campaign Name",
      dataIndex: "campaignName",
      key: "campaignName",
    },
    {
      title: "Created by",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
      render: (text, record) => (
        <Button
          onClick={() => {
            handleViewBookings(
              record.inventories,
              record.packageRate,
              record?.suffixInventories
            );
          }}
        >
          View More
        </Button>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text, record) => {
        const isNotCreator = userId !== record?.creatorId;
        const isSONotCreated = !record?.bdfDetails?.createdSO;
        const isBDFNotDownloaded = !record?.isBDFDownloaded;
        const isDisabled = isNotCreator || isSONotCreated || isBDFNotDownloaded;

        const tooltipTitle = isNotCreator
          ? "Only BDF creator can send email."
          : isSONotCreated
          ? "Can't send mail before sending BDF to Sales Order!"
          : isBDFNotDownloaded
          ? "Download the BDF Excel once to send the mail!"
          : "";

        return (
          <Tooltip title={tooltipTitle}>
            <span>
              {" "}
              {/* Wrapping in span to handle the tooltip properly */}
              <IoIosMail
                style={{
                  fontSize: "24px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.5 : 1,
                  color: record.isEmailSent ? "green" : "inherit",
                }}
                onClick={() => {
                  if (!isDisabled) {
                    handleOpenModal(record);
                  }
                }}
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "BDF",
      dataIndex: "bdf",
      key: "bdf",
      render: (text, record) => (
        <Button
          onClick={async () => {
            const logs = await fetchBdfLogs(record?.bdfDetails?._id);
            const secondLastLog =
              logs.length > 1
                ? logs[logs.length - 2]
                : logs[logs.length - 1] || {};

            // Update BDF download status
            try {
              const response = await fetch(
                `${apiBaseUrl}/inventoryManagement/updateBDFExcelDownloadStatus`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    bdfId: record?.bdfDetails?._id,
                  }),
                }
              );

              if (response.ok) {
                setFetched((prev) => !prev); // Refresh the data
              }
            } catch (error) {
              console.error("Error updating BDF download status:", error);
            }

            handleBookingClick(
              record?.inventories,
              record?.bdfDetails,
              record?.suffixInventories,
              secondLastLog
            );
          }}
          style={{
            borderColor: record.isBDFDownloaded ? "#52c41a" : undefined,
            color: record.isBDFDownloaded ? "#52c41a" : undefined,
          }}
        >
          BDF
        </Button>
      ),
    },
    {
      title: "History",
      dataIndex: "history",
      key: "history",
      render: (text, record) => {
        const searchParams = new URLSearchParams();

        // Only include filters that are applied
        Object.entries(filtersBDF).forEach(([key, value]) => {
          if (value) {
            if (key === "dateRange" && value.length === 2) {
              // Store both dates as separate parameters
              searchParams.set("startDate", encodeURIComponent(value[0]));
              searchParams.set("endDate", encodeURIComponent(value[1]));
            } else {
              searchParams.set(key, value);
            }
          }
        });

        return (
          <span
            onClick={() => {
              navigate(
                `/bdfLogs/${record?.bdfDetails?._id}?${searchParams.toString()}`
              );
            }}
            style={{
              color: "#1677ff",
              cursor: "pointer",
            }}
          >
            View
          </span>
        );
      },
    },
    {
      title: "Edit",
      dataIndex: "Edit",
      key: "edit",
      render: (text, record) => {
        const isLocked = record?.bdfDetails?.isLocked;

        if (isLocked) {
          return (
            <Tooltip title="Editing is locked as bill is generated!">
              <PiPencilSimpleSlashFill />
            </Tooltip>
          );
        }

        return isAbleToModifyBooking(record?.creatorId, userId) ? (
          <Button
            onClick={() => handleEditBDF(record?.bdfDetails?._id)}
            style={{ border: "none" }}
          >
            <PiPencilSimpleFill />
          </Button>
        ) : (
          <Tooltip title="Editing not allowed">
            <PiPencilSimpleSlashFill />
          </Tooltip>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        if (record?.bdfDetails?.createdSO) {
          return (
            <Tooltip title="Archiving for created sales order not allowed!">
              <MdArchive style={{ color: "gray", fontSize: "1rem" }} />
            </Tooltip>
          );
        }

        if (isAbleToModifyBooking(record?.creatorId, userId)) {
          return record?.bdfDetails?._id ? (
            <Popconfirm
              title="Archive Booking"
              placement="topRight"
              description="Are you sure you want to archive?"
              onConfirm={() => handleArchiveBDF(record?.bdfDetails?._id)}
              okText="Yes"
              cancelText="No"
            >
              <MdArchive style={{ fontSize: "1.3rem", cursor: "pointer" }} />
            </Popconfirm>
          ) : (
            <Tooltip title="Archiving not allowed!">
              <MdArchive style={{ color: "gray", fontSize: "1rem" }} />
            </Tooltip>
          );
        }
      },
    },
    {
      title: "Duplicate",
      dataIndex: "duplicate",
      key: "duplicate",
      render: (text, record) =>
        isAbleToModifyBooking(record?.creatorId, userId) ? (
          <Button
            style={{ border: "none" }}
            onClick={() => handleDuplicate(record)}
          >
            <IoDuplicate />
          </Button>
        ) : (
          <>
            <Tooltip title="Duplicating not allowed">
              <Button style={{ border: "none" }} disabled>
                <IoDuplicate />
              </Button>
            </Tooltip>
          </>
        ),
    },
    {
      title: "Sub BDF",
      dataIndex: "subBdf",
      key: "subBdf",
      render: (text, record) =>
        isAbleToModifyBooking(record?.creatorId, userId) ? (
          <Button
            style={{ border: "none" }}
            onClick={() => handleSubBdf(record)}
          >
            <HiDocumentDuplicate />
          </Button>
        ) : (
          <>
            <Tooltip title="Duplicating not allowed">
              <Button style={{ border: "none" }} disabled>
                <HiDocumentDuplicate />
              </Button>
            </Tooltip>
          </>
        ),
    },
    {
      title: "Premium",
      dataIndex: "createPremium",
      key: "createPremium",
      render: (_, record) => {
        const canConvert =
          !record?.bdfDetails?.createdSO &&
          !record?.bdfDetails?.isLocked &&
          isAbleToModifyBooking(record?.creatorId, userId);

        if (record?.bdfDetails?.createdSO) {
          return (
            <Tooltip title="Cannot create Premium Block: Sales Order exists (archiving not allowed)">
              <Button style={{ border: "none" }} disabled>
                <FaLock style={{ color: "gray" }} />
              </Button>
            </Tooltip>
          );
        }

        if (record?.bdfDetails?.isLocked) {
          return (
            <Tooltip title="Cannot create Premium Block: BDF is locked">
              <Button style={{ border: "none" }} disabled>
                <FaLock style={{ color: "gray" }} />
              </Button>
            </Tooltip>
          );
        }

        if (!canConvert) {
          return (
            <Tooltip title="Not allowed">
              <Button style={{ border: "none" }} disabled>
                <FaLock style={{ color: "gray" }} />
              </Button>
            </Tooltip>
          );
        }

        return (
          <Tooltip title="Create Premium Block from BDF">
            <Button
              style={{ border: "none" }}
              onClick={() => handleCreatePremiumFromBdf(record)}
            >
              <HiDocumentDuplicate style={{ fontSize: "1.15rem" }} />
            </Button>
          </Tooltip>
        );
      },
    },
  ];
  const columnBookingsSub = [
    {
      title: "Send to SO",
      dataIndex: "select",
      key: "select",
      render: (_, record) => {
        return (
          <Checkbox
            onChange={() => handleCheckboxChange(record)}
            checked={
              record.bdfDetails.createdSO ||
              selectedRows.includes(record.bdfDetails._id)
            }
            disabled={record.bdfDetails.createdSO}
            className={
              record.bdfDetails.createdSO ? "custom-disabled-checkbox" : ""
            }
          />
        );
      },
    },
    {
      title: "Serial No.",
      dataIndex: "serial",
      key: "serial",
    },
    {
      title: "BDF SERIAL No.",
      dataIndex: "bdfSerial",
      key: "bdfSerial",
    },
    {
      title: "Booked On",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Campaign Name",
      dataIndex: "campaignName",
      key: "campaignName",
    },
    {
      title: "Created by",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
      render: (text, record) => (
        <Button
          onClick={() => handleViewBookings(record.inventories, record.packageRate)}
        >
          View More
        </Button>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      render: (text, record) => {
        const isLocked = record?.bdfDetails?.isLocked;

        if (isLocked) {
          return (
            <Tooltip title="Editing is locked as bill is generated!">
              <PiPencilSimpleSlashFill />
            </Tooltip>
          );
        }

        return isAbleToModifyBooking(record?.creatorId, userId) ? (
          <Button
            onClick={() => openSubBdfEditModal(record)}
            style={{ border: "none" }}
          >
            <PiPencilSimpleFill />
          </Button>
        ) : (
          <Tooltip title="Editing not allowed">
            <PiPencilSimpleSlashFill />
          </Tooltip>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text, record) => {
        const isNotCreator = userId !== record?.creatorId;
        const isSONotCreated = !record?.bdfDetails?.createdSO;
        const isBDFNotDownloaded = !record?.isBDFDownloaded;
        const isDisabled = isNotCreator || isSONotCreated || isBDFNotDownloaded;

        const tooltipTitle = isNotCreator
          ? "Only BDF creator can send email."
          : isSONotCreated
          ? "Can't send mail before sending BDF to Sales Order!"
          : isBDFNotDownloaded
          ? "Download the BDF Excel once to send the mail!"
          : "";

        return (
          <Tooltip title={tooltipTitle}>
            <span>
              <IoIosMail
                style={{
                  fontSize: "24px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.5 : 1,
                  color: record.isEmailSent ? "green" : "inherit",
                }}
                onClick={() => {
                  if (!isDisabled) {
                    handleOpenModal(record, false, true);
                  }
                }}
              />
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "BDF",
      dataIndex: "bdf",
      key: "bdf",
      render: (text, record) => (
        <Button
          style={{
            borderColor: record.isBDFDownloaded ? "#52c41a" : undefined,
            color: record.isBDFDownloaded ? "#52c41a" : undefined,
          }}
          onClick={async () => {
            const logs = await fetchBdfLogs(record?.bdfDetails?._id);
            const secondLastLog =
              logs.length > 1
                ? logs[logs.length - 2]
                : logs[logs.length - 1] || {};

            try {
              const response = await fetch(
                `${apiBaseUrl}/inventoryManagement/updateBDFExcelDownloadStatus`,
                {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    bdfId: record?.bdfDetails?._id,
                  }),
                }
              );

              if (response.ok) {
                setFetched((prev) => !prev);
              }
            } catch (error) {
              console.error("Error updating BDF download status:", error);
            }

            handleSubBookingClick(
              record.inventories,
              record.bdfDetails,
              true,
              secondLastLog
            );
          }}
        >
          BDF
        </Button>
      ),
    },
    {
      title: "History",
      dataIndex: "history",
      key: "history",
      render: (text, record) => {
        const searchParams = new URLSearchParams();

        Object.entries(filtersBDF).forEach(([key, value]) => {
          if (value) {
            if (key === "dateRange" && value.length === 2) {
              searchParams.set("startDate", encodeURIComponent(value[0]));
              searchParams.set("endDate", encodeURIComponent(value[1]));
            } else {
              searchParams.set(key, value);
            }
          }
        });

        return (
          <span
            onClick={() => {
              navigate(
                `/bdfLogs/${record?.bdfDetails?._id}?${searchParams.toString()}`
              );
            }}
            style={{
              color: "#1677ff",
              cursor: "pointer",
            }}
          >
            View
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        // Same as Bookings tab: no delete when SO already created
        if (record?.bdfDetails?.createdSO) {
          return (
            <Tooltip title="Archiving for created sales order not allowed!">
              <MdDelete style={{ color: "gray", fontSize: "1rem" }} />
            </Tooltip>
          );
        }

        if (isAbleToModifyBooking(record?.creatorId, userId)) {
          return (
            <Popconfirm
              title="Delete Booking"
              placement="topRight"
              description="Are you sure you want to delete?"
              onConfirm={() => handleDeleteSubBDF(record?.bdfDetails?._id)}
              okText="Yes"
              cancelText="No"
            >
              <MdDelete
                style={{ color: "red", fontSize: "1rem", cursor: "pointer" }}
              />
            </Popconfirm>
          );
        }

        return (
          <Tooltip title="Deleting not allowed">
            <MdDeleteForever style={{ color: "gray", fontSize: "1rem" }} />
          </Tooltip>
        );
      },
    },
  ];

  const columns = [
    {
      title: "Location Area",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      align: "center",
      render: (text) => (
        <div style={{ textAlign: "center" }}>
          {text != null && text !== "" ? text : "-"}
        </div>
      ),
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
      align: "center",
      render: (text) => (
        <div style={{ textAlign: "center" }}>
          {text != null && text !== "" ? text : "-"}
        </div>
      ),
    },
    {
      title: "Printing Charge",
      dataIndex: "printingCharge",
      key: "printingCharge",
      editable: true,
      render: (_, record) => (
        <Input
          disabled={packageRate}
          value={record.printingCharge}
          onChange={(e) =>
            handleEdit(e.target.value, record._id, "printingCharge")
          }
        />
      ),
    },
    {
      title: "Mounting Charge",
      dataIndex: "mountingCharge",
      key: "mountingCharge",
      editable: true,
      render: (_, record) => (
        <Input
          disabled={packageRate}
          value={record.mountingCharge}
          onChange={(e) =>
            handleEdit(e.target.value, record._id, "mountingCharge")
          }
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div style={{ textAlign: "center" }}>
          <Popconfirm
            title="Remove Inventory"
            placement="topRight"
            description="Are you sure you want to remove this inventory?"
            onConfirm={() => handleRemoveInventory(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <MdDelete
              style={{ color: "red", fontSize: "1rem", cursor: "pointer" }}
            />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleDuplicate = (record) => {
    // Sales Order charge lines are stored with BDF inventories for PO handling,
    // but a duplicated BDF must contain only real inventory records.
    let info = (record?.inventories || [])
      .filter(
        (item) =>
          !["AGENCY_COMMISSION", "TRANSPORTATION"].includes(item?.lineType) &&
          item?.invId?._id,
      )
      .map((item) => {
        // console.log("Record is:", record);
        // console.log("Item is:", item)

        const formattedStartDate = dayjs(item?.startDate).isValid()
          ? dayjs(item?.startDate).format("DD-MM-YYYY")
          : null;

        const formattedEndDate = dayjs(item?.endDate).isValid()
          ? dayjs(item?.endDate).format("DD-MM-YYYY")
          : null;

        return {
          _id: item.invId._id,
          codeNo: item?.invId?.CodeNo,
          location: item?.invId?.locations?.name,
          ratePerMonth: item?.rpm,
          mountingCharge: item?.mountingCharge,
          printingCharge: item?.printingCharge,
          specialRate: item?.specialRate,
          specialRatePerMonth: item?.specialRatePerMonth,
          innovationRate: item?.innovationRate || 0,
          // startDate: formattedStartDate,
          // endDate: formattedEndDate,
          blockedDates: item?.invId?.blockedDates || [],
          Bookings: item?.invId?.Bookings || [],
          premiumBlock: item?.invId?.premiumBlock || [],
          removedOn: item?.invId?.removedOn,
          isArchived: item?.invId?.isArchived,
          isOverlapPossible: item?.invId?.isOverlapPossible,
        };
      });

    let dt = {
      GST: record?.bdfDetails?.brandId?.partyCompany?.gstNumber,
      clientName: record?.bdfDetails?.brandId?.partyName,
      salesPerson: record?.bdfDetails?.salesPerson,
      approvedBy: record?.bdfDetails?.approvedBy,
      clientId: record?.bdfDetails?.brandId?.partyCompany?._id,
      brandName: record?.bdfDetails?.brandId?.brandName,
      brandSegment: record?.bdfDetails?.brandSegment,
      packageRate: record?.packageRate,
      creditPeriod: record?.bdfDetails?.creditPeriod,
      mediaPlannerName: record?.bdfDetails?.mediaPlannerName,
      clientCategory: record?.bdfDetails?.clientCategory,
      leadFrom: record?.bdfDetails?.leadFrom,
      bdfType: record?.bdfDetails?.bdfType,
      campaignName: record?.bdfDetails?.campaignName,
      billingPartyName: record?.bdfDetails?.billingPartyName,
      billingAddress: record?.bdfDetails?.billingAddress,
      remark: record?.bdfDetails?.remark,
      emailId: record?.bdfDetails?.emailId,
      contactPerson: record?.bdfDetails?.contactPerson,
      contactNumber: record?.bdfDetails?.contactNumber,
      invs: info,
    };
    dispatch(addProposalInventories(dt));
    navigate(`/clients-bdf/direct-bdf`, { state: { recordId: record?._id } });
  };

  const handleSubBdf = (record) => {
    setPrintingZeroedSnapshot(null);
    setMountingZeroedSnapshot(null);
    resetSubBdfOptionalFields();
    if (record && record.inventories) {
      setSubBDFId(record?.bdfDetails?._id);
      const pool = record.inventories
        .filter((ele) => !ele?.suffixCode)
        .map((ele) => mapInventoryLineForSubBdf(ele));
      setParentInventoryPool(pool);
      setSubBdfRoFile(record?.bdfDetails?.roFile || null);
      setInventories(pool.map((item) => ({ ...item })));
    }
    setSubBDFModalOpen(true);
  };

  const setAllPrintingToZero = () => {
    setInventories((prev) => {
      if (!prev) return prev;
      setPrintingZeroedSnapshot(prev.map((item) => ({ ...item })));
      return prev.map((item) => ({ ...item, printingCharge: 0 }));
    });
    notification.success({ message: "Printing charge set to 0 for all" });
  };

  const revertPrinting = () => {
    if (printingZeroedSnapshot && inventories) {
      setInventories((prev) =>
        prev.map((item) => {
          const snap = printingZeroedSnapshot.find((s) => s._id === item._id);
          return snap ? { ...item, printingCharge: snap.printingCharge } : item;
        }),
      );
      setPrintingZeroedSnapshot(null);
    }
  };

  const setAllMountingToZero = () => {
    setInventories((prev) => {
      if (!prev) return prev;
      setMountingZeroedSnapshot(prev.map((item) => ({ ...item })));
      return prev.map((item) => ({ ...item, mountingCharge: 0 }));
    });
    notification.success({ message: "Mounting charge set to 0 for all" });
  };

  const revertMounting = () => {
    if (mountingZeroedSnapshot && inventories) {
      setInventories((prev) =>
        prev.map((item) => {
          const snap = mountingZeroedSnapshot.find((s) => s._id === item._id);
          return snap ? { ...item, mountingCharge: snap.mountingCharge } : item;
        }),
      );
      setMountingZeroedSnapshot(null);
    }
  };

  const detailedBookingsColumn = [
    {
      title: "Code",
      dataIndex: "CodeNo",
      key: "CodeNo",
    },
    {
      title: "Location",
      dataIndex: "area",
      key: "area",
    },
    {
      title: (<div>Printing <br/>Charge</div>),
      dataIndex: "printingCharge",
      key: "printingCharge",
    },
    {
      title:  (<div>Mounting <br/>Charge</div>),
      dataIndex: "mountingCharge",
      key: "mountingCharge",
    },
    {
      title: (<div>Special Rate <br/>(Duration)</div>),
      dataIndex: "specialRate",
      key: "specialRate",
    },
    {
      title: (<div>Start <br/>Date</div>),
      dataIndex: "startDate",
      key: "start Date",
    },
    {
      title:  (<div>End <br/>Date</div>),
      dataIndex: "endDate",
      key: "endDate",
    },
  ];

  const suffixBookingsColumn = [
    {
      title: "Suffix Code",
      dataIndex: "suffixCode",
      key: "suffixCode",
    },
    {
      title: "Suffix Info",
      dataIndex: "suffixInfo",
      key: "suffixInfo",
    },
    {
      title: "Special Rate",
      dataIndex: "specialRate",
      key: "specialRate",
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
    },
  ];

  const dataBookings = bookings?.BDFDetails?.reduce((acc, ele, ind) => {
    // console.log("Element at index", ind, ":", ele);
    if (ele.accepted) {
      const { inventories, suffixInventories, ...bdfDetails } = ele;
      acc.push({
        _id: ele?._id,
        isEmailSent: ele?.isEmailSent,
        isBDFDownloaded: ele?.isBDFDownloaded,
        serial: ele?.stamp,
        bdfSerial: ele?.bdfId?.stamp,
        date: moment(ele?.createdAt).format("DD-MM-YYYY"),
        bdfDetails,
        createdBy: ele?.createdBy?.name,
        creatorId: ele?.createdBy?._id,
        inventories,
        suffixInventories,
        packageRate: ele?.packageRate,
        campaignName: ele?.campaignName,
      });
    }
    return acc;
  }, []);

  const handleCheckboxChange = (record) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(record.bdfDetails._id)) {
        return prevSelectedRows.filter((id) => id !== record.bdfDetails._id);
      } else {
        return [...prevSelectedRows, record.bdfDetails._id];
      }
    });
  };

  const handleConfirm = async () => {
    setConfirmLoading(true);
    const requestBody = {
      bdfIds: selectedRows,
      subBdfBool,
    };

    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/addToSalesOrder`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      if (response.ok) {
        notification.success({
          message: responseData?.message,
        });
        setFetched((prev) => !prev);
      } else {
        notification.error({
          message: responseData?.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error Occurred",
      });
    } finally {
      setConfirmLoading(false);
    }
  };
  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };
  const saveSubBdf = async () => {
    const trimmedCampaign = campaignName?.trim().toUpperCase();
    let data = {
      bdfId: subBDFId,
      inventories: inventories,
      bdfDate: bdfDate ? dayjs(bdfDate).format("DD-MM-YYYY") : null,
    };
    if (trimmedCampaign) {
      data.campaignName = trimmedCampaign;
    }
    if (subBdfParentCompanyId) {
      data.parentCompanyId = subBdfParentCompanyId;
    }
    if (subBdfBrandId) {
      data.brandId = subBdfBrandId;
    }
    if (subBdfRoFile) {
      data.roFile = subBdfRoFile;
    }
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/createSubBDF`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      let responseData = await response.json();
      if (responseData.success) {
        notification.success({ message: responseData.message });
        setFetched((prev) => !prev);
        setSubBDFModalOpen(false);
        setBdfDate(null);
        resetSubBdfOptionalFields();
        navigate("/clients-bookings?tab=3");
      } else {
        notification.error({ message: responseData.message });
      }
    } catch (error) {
      console.error("Error: ", error.message);
    }
  };

  return (
    <>
      <div>
        <h4 style={{ color: "gray", marginBottom: "1rem" }}>Client Info</h4>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            marginBottom: "1rem",
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", gap: "1rem" }}>
            <div style={{ color: "gray" }}>Name: </div>
            <div>{bookings?.contactPerson}</div>
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div style={{ color: "gray" }}>Email: </div>
            <div>{bookings?.emailId}</div>
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div style={{ color: "gray" }}>Contact: </div>
            <div>{bookings?.contactNumber}</div>
          </div>
        </div>
        <h4
          style={{
            color: "gray",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Bookings Info
        </h4>

        <div style={{ overflow: "auto" }}>
          <TableComponent
            dataSource={dataBookings}
            columns={subBdfBool ? columnBookingsSub : columnBookings}
          />

          {selectedRows.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginRight: "1rem",
              }}
            >
              <Button
                type="primary"
                onClick={handleConfirm}
                loading={confirmLoading}
                disabled={confirmLoading}
              >
                {confirmLoading ? "Processing..." : "Confirm"}
              </Button>
            </div>
          )}
        </div>
        <Modal
          open={modalVisibleEmail}
          onCancel={handleCancelEmail}
          title="Send BDF"
          maskClosable={!sendBdfEmailLoading}
          keyboard={!sendBdfEmailLoading}
          closable={!sendBdfEmailLoading}
          footer={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              <Tooltip
                title={
                  emailAttachments.length >= 10
                    ? "You can attach up to 10 files"
                    : "Add documents to this email"
                }
              >
                <span>
                  <Button
                    icon={<FaPaperclip />}
                    onClick={() => emailAttachmentInputRef.current?.click()}
                    loading={emailAttachmentUploading}
                    disabled={
                      sendBdfEmailLoading ||
                      emailAttachmentUploading ||
                      emailAttachments.length >= 10
                    }
                  >
                    Attach files
                  </Button>
                </span>
              </Tooltip>
              <Button
                key="send"
                type="primary"
                loading={sendBdfEmailLoading}
                disabled={sendBdfEmailLoading || emailAttachmentUploading}
                onClick={handleOkEmail}
                style={{
                  borderRadius: "50px",
                  backgroundColor: "#0957D0",
                  borderColor: "#0957D0",
                }}
              >
                Send
              </Button>
            </div>
          }
        >
          <div style={{ height: "100%", width: "100%" }}>
            <div
              style={{ width: "500px", position: "relative", border: "0px" }}
            >
              <ReactQuill
                value={bodyOfEmail}
                onChange={handleTextArea}
                placeholder="Content of the body"
                modules={modules}
                formats={formats}
                style={{ height: "300px", border: "0px", outline: "none" }}
              />
              <style jsx>{`
                .ql-toolbar {
                  position: absolute;
                  bottom: -45px;
                  left: 0;
                  right: 0;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  border: 0px !important; /* Ensure no border on toolbar */
                }
                .ql-container {
                  border: 0px !important; /* Remove border from editor container */
                }
                .ql-editor {
                  border: 0px !important; /* Remove border from the editable area */
                  outline: none; /* Remove any outline on focus */
                }
              `}</style>
            </div>
            <div style={{ marginTop: 52, width: 500 }}>
              <input
                ref={emailAttachmentInputRef}
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={handleEmailAttachmentSelect}
                disabled={sendBdfEmailLoading || emailAttachmentUploading}
              />
              {emailAttachments.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {emailAttachments.map((file, index) => (
                    <div
                      key={`${file.url}-${index}`}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        maxWidth: 240,
                        padding: "4px 8px 4px 10px",
                        borderRadius: 16,
                        background: "#f4f7fb",
                        border: "1px solid #d6e4f0",
                        fontSize: 12,
                        lineHeight: "18px",
                      }}
                    >
                      <FaPaperclip size={11} color="#595959" />
                      <span
                        title={file.name}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </span>
                      <button
                        type="button"
                        aria-label={`Remove ${file.name}`}
                        disabled={sendBdfEmailLoading || emailAttachmentUploading}
                        onClick={() =>
                          setEmailAttachments((prev) =>
                            prev.filter((_, fileIndex) => fileIndex !== index)
                          )
                        }
                        style={{
                          border: 0,
                          background: "transparent",
                          color: "#8c8c8c",
                          cursor: "pointer",
                          padding: 0,
                          fontSize: 14,
                          lineHeight: 1,
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Modal>

        <Modal
          title="Bookings"
          open={bookingsModalOpen}
          onCancel={() => {
            setBookingsModalOpen(false);
          }}
          onOk={() => {
            setBookingsModalOpen(false);
          }}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div className="bdfbased-booking-detail">
            <TableComponent
              dataSource={detailedBookingsData}
              columns={detailedBookingsColumn}
            />
            {suffixBookingsData && suffixBookingsData.length > 0 && (
              <>
                <h6 style={{ marginTop: "20px" }}>Suffix Inventory Details</h6>
                <TableComponent
                  dataSource={suffixBookingsData}
                  columns={suffixBookingsColumn}
                />
              </>
            )}
            {packageRate && (
              <div
                style={{ display: "flex", alignItems: "center", gap: ".5rem" }}
              >
                <h6 style={{ margin: "0" }}>
                  Package Rate : ₹ {formatIndianNumber(packageRate)}
                </h6>
              </div>
            )}
          </div>
        </Modal>

        <Modal
          title="Edit Sub-BDF"
          open={subBdfEditModalOpen}
          onCancel={() => {
            if (subBdfEditSaving) return;
            setSubBdfEditModalOpen(false);
            resetSubBdfEditFields();
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                if (subBdfEditSaving) return;
                setSubBdfEditModalOpen(false);
                resetSubBdfEditFields();
              }}
            >
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              loading={subBdfEditSaving}
              disabled={
                subBdfEditSaving ||
                !subBdfEditId ||
                !subBdfEditBdfDate ||
                !subBdfEditInventories ||
                subBdfEditInventories.length === 0
              }
              onClick={saveSubBdfEdits}
            >
              Save
            </Button>,
          ]}
          centered
          width={1000}
          maskClosable={!subBdfEditSaving}
          keyboard={!subBdfEditSaving}
          closable={!subBdfEditSaving}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              flexWrap: "wrap",
              marginBottom: 12,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <label style={{ margin: 0, fontWeight: 600 }}>
                Sub BDF date <span style={{ color: "#ff4d4f" }}>*</span>
              </label>
              <DatePicker
                style={{ width: 200 }}
                format="DD-MM-YYYY"
                placeholder="DD-MM-YYYY"
                value={subBdfEditBdfDate}
                onChange={(date) => setSubBdfEditBdfDate(date)}
                disabled={subBdfEditSaving}
              />
            </div>
            <Button
              type="primary"
              disabled={subBdfEditSaving}
              onClick={() => openSubBdfInvPicker("edit")}
            >
              Add Inventories
            </Button>
          </div>
          <Table
            rowKey="_id"
            pagination={false}
            dataSource={subBdfEditInventories}
            components={components}
            columns={[
              {
                title: "Code No.",
                dataIndex: "code",
                key: "code",
                width: 140,
              },
              {
                title: "Location",
                dataIndex: "location",
                key: "location",
              },
              {
                title: "Width",
                dataIndex: "width",
                key: "width",
                align: "center",
                width: 80,
                render: (text) => (
                  <div style={{ textAlign: "center" }}>
                    {text != null && text !== "" ? text : "-"}
                  </div>
                ),
              },
              {
                title: "Height",
                dataIndex: "height",
                key: "height",
                align: "center",
                width: 80,
                render: (text) => (
                  <div style={{ textAlign: "center" }}>
                    {text != null && text !== "" ? text : "-"}
                  </div>
                ),
              },
              {
                title: "Printing Charge",
                dataIndex: "printingCharge",
                key: "printingCharge",
                render: (_, record) => (
                  <Input
                    value={record.printingCharge}
                    disabled={subBdfEditSaving}
                    onChange={(e) =>
                      handleSubBdfEditField(
                        e.target.value,
                        record._id,
                        "printingCharge"
                      )
                    }
                  />
                ),
              },
              {
                title: "Mounting Charge",
                dataIndex: "mountingCharge",
                key: "mountingCharge",
                render: (_, record) => (
                  <Input
                    value={record.mountingCharge}
                    disabled={subBdfEditSaving}
                    onChange={(e) =>
                      handleSubBdfEditField(
                        e.target.value,
                        record._id,
                        "mountingCharge"
                      )
                    }
                  />
                ),
              },
              {
                title: "Action",
                key: "action",
                align: "center",
                render: (_, record) => (
                  <Popconfirm
                    title="Remove Inventory"
                    description="Remove this inventory from Sub BDF?"
                    onConfirm={() =>
                      handleSubBdfEditRemoveInventory(record._id)
                    }
                    okText="Yes"
                    cancelText="No"
                    disabled={subBdfEditSaving}
                  >
                    <MdDelete
                      style={{
                        color: subBdfEditSaving ? "gray" : "red",
                        fontSize: "1rem",
                        cursor: subBdfEditSaving ? "not-allowed" : "pointer",
                      }}
                    />
                  </Popconfirm>
                ),
              },
            ]}
          />

          <Divider style={{ margin: "20px 0 16px" }} />

          <div className="sub-bdf-form-section">
            <div className="sub-bdf-optional-panel">
              <div className="sub-bdf-optional-panel__intro">
                <div className="sub-bdf-optional-panel__title">
                  Campaign / Party / Brand
                </div>
                <p className="sub-bdf-optional-panel__description">
                  Prefills from the current Sub BDF. Change campaign name, party
                  company, or brand when this Sub BDF should differ — same as
                  create Sub BDF. Sales Order / Billing drafts without invoices
                  are rolled back to pending so they stay in sync.
                </p>
              </div>

              <div className="sub-bdf-optional-fields">
                {renderSubBdfRoSection({
                  roFile: subBdfEditRoFile,
                  uploading: subBdfEditRoUploading,
                  inputId: "subBdfEditRoInput",
                  onFileSelect: handleSubBdfEditRoFileSelect,
                })}

                <div className="sub-bdf-field-group">
                  <label className="sub-bdf-label">
                    Campaign name
                    <span className="sub-bdf-optional-tag">(Editable)</span>
                  </label>
                  <p className="sub-bdf-field-hint">
                    Update when this Sub BDF needs a different campaign name.
                  </p>
                  <Input
                    size="middle"
                    className="sub-bdf-control"
                    style={{ width: "100%" }}
                    placeholder="Enter Campaign Name"
                    value={subBdfEditCampaignName}
                    disabled={subBdfEditSaving}
                    onChange={(e) =>
                      setSubBdfEditCampaignName(e.target.value.toUpperCase())
                    }
                  />
                </div>

                <div className="sub-bdf-field-group">
                  <label className="sub-bdf-label">
                    Party Company
                    <span className="sub-bdf-optional-tag">(Editable)</span>
                  </label>
                  <p className="sub-bdf-field-hint">
                    Change only if the Sub BDF should be billed or tracked under
                    a different party. Billing party details update from the
                    selected party.
                  </p>
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Select Party Company"
                    size="middle"
                    className="sub-bdf-control"
                    style={{ width: "100%" }}
                    value={subBdfEditParentCompanyId}
                    disabled={subBdfEditSaving}
                    options={partyMasterOptions.map((p) => ({
                      value: p._id,
                      label: p.partyName,
                    }))}
                    filterOption={(input, option) =>
                      (option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                    onChange={(value) => {
                      setSubBdfEditParentCompanyId(value ?? null);
                      setSubBdfEditBrandId(null);
                      setSubBdfEditNewBrandName("");
                      setSubBdfEditBrandSearch("");
                      if (value) {
                        fetchBrandsForParty(value);
                      } else {
                        setBrandsForParty([]);
                      }
                    }}
                  />
                </div>

                <div className="sub-bdf-field-group sub-bdf-field-group--last">
                  <label className="sub-bdf-label">
                    Brand
                    <span className="sub-bdf-optional-tag">(Editable)</span>
                  </label>
                  <p className="sub-bdf-field-hint">
                    Select a brand under the party above, or type a new name
                    to create it under this party.
                  </p>
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder={
                      subBdfEditParentCompanyId
                        ? "Select or type Brand"
                        : "Select Party Company first"
                    }
                    size="middle"
                    className="sub-bdf-control"
                    style={{ width: "100%" }}
                    disabled={!subBdfEditParentCompanyId || subBdfEditSaving}
                    loading={brandsLoading}
                    searchValue={subBdfEditBrandSearch}
                    onSearch={(text, info) => {
                      // keep typed text when the box loses focus
                      if (info?.source === "blur") return;
                      setSubBdfEditBrandSearch(text.toUpperCase());
                    }}
                    onBlur={() => {
                      const typed = subBdfEditBrandSearch.trim().toUpperCase();
                      if (!typed) return;
                      const match = brandsForParty.find(
                        (b) =>
                          (b.brandName || "").trim().toUpperCase() === typed
                      );
                      if (match) {
                        setSubBdfEditBrandId(match._id);
                        setSubBdfEditNewBrandName("");
                      } else {
                        setSubBdfEditBrandId(null);
                        setSubBdfEditNewBrandName(typed);
                      }
                      setSubBdfEditBrandSearch("");
                    }}
                    value={
                      subBdfEditBrandId ||
                      (subBdfEditNewBrandName
                        ? `__new__${subBdfEditNewBrandName}`
                        : null)
                    }
                    options={(() => {
                      const opts = brandsForParty.map((b) => ({
                        value: b._id,
                        label: b.brandName,
                      }));
                      const typed = (
                        subBdfEditBrandSearch || subBdfEditNewBrandName
                      ).trim();
                      if (
                        typed &&
                        !opts.some(
                          (o) =>
                            (o.label || "").toLowerCase() ===
                            typed.toLowerCase()
                        )
                      ) {
                        opts.push({
                          value: `__new__${typed}`,
                          label: subBdfEditBrandSearch
                            ? `Create new brand "${typed.toUpperCase()}"`
                            : typed.toUpperCase(),
                        });
                      }
                      return opts;
                    })()}
                    filterOption={(input, option) =>
                      String(option?.value).startsWith("__new__") ||
                      (option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                    onChange={(value) => {
                      setSubBdfEditBrandSearch("");
                      if (value && String(value).startsWith("__new__")) {
                        setSubBdfEditBrandId(null);
                        setSubBdfEditNewBrandName(
                          String(value).slice("__new__".length)
                        );
                      } else {
                        setSubBdfEditBrandId(value ?? null);
                        setSubBdfEditNewBrandName("");
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          title="Sub BDF"
          open={subBDFModalOpen}
          onCancel={() => {
            setSubBDFModalOpen(false);
            setBdfDate(null);
            resetSubBdfOptionalFields();
            setPrintingZeroedSnapshot(null);
            setMountingZeroedSnapshot(null);
          }}
          onOk={() => {
            setSubBDFModalOpen(false);
            setBdfDate(null);
            resetSubBdfOptionalFields();
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setSubBDFModalOpen(false);
                setBdfDate(null);
                resetSubBdfOptionalFields();
                setPrintingZeroedSnapshot(null);
                setMountingZeroedSnapshot(null);
              }}
            >
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              loading={subBdfSaving}
              disabled={
                subBdfSaving || !bdfDate || !inventories || inventories.length === 0
              }
              onClick={async () => {
                try {
                  setSubBdfSaving(true);
                  await saveSubBdf();
                } finally {
                  setSubBdfSaving(false);
                }
              }}
            >
              Save
            </Button>,
          ]}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
              flexWrap: "wrap",
              marginBottom: 12,
            }}
          >
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {inventories?.length > 0 && (
                <>
                  <Button
                    size="small"
                    onClick={
                      printingZeroedSnapshot
                        ? revertPrinting
                        : setAllPrintingToZero
                    }
                    disabled={packageRate}
                  >
                    {printingZeroedSnapshot
                      ? "Revert Printing"
                      : "Set Printing to 0 for all"}
                  </Button>
                  <Button
                    size="small"
                    onClick={
                      mountingZeroedSnapshot ? revertMounting : setAllMountingToZero
                    }
                    disabled={packageRate}
                  >
                    {mountingZeroedSnapshot
                      ? "Revert Mounting"
                      : "Set Mounting to 0 for all"}
                  </Button>
                </>
              )}
            </div>
            <Button type="primary" onClick={() => openSubBdfInvPicker("create")}>
              Add Inventories
            </Button>
          </div>
          <div style={{ width: "100%", overflow: "auto" }}>
            <Table
              components={components}
              columns={columns}
              dataSource={inventories?.map((item) => ({
                ...item,
                key: item._id,
              }))}
            />
          </div>

          <Divider style={{ margin: "20px 0 16px" }} />

          <div className="sub-bdf-form-section">
            <div className="sub-bdf-required-block">
              <label className="sub-bdf-label sub-bdf-label--required">
                Sub BDF date
                <span className="sub-bdf-required-star">*</span>
              </label>
              <DatePicker
                size="middle"
                className="sub-bdf-date-picker"
                style={{ width: "100%", maxWidth: 280 }}
                format="DD-MM-YYYY"
                placeholder="DD-MM-YYYY"
                value={bdfDate}
                onChange={(date) => setBdfDate(date)}
              />
            </div>

            <div className="sub-bdf-optional-panel">
              <div className="sub-bdf-optional-panel__intro">
                <div className="sub-bdf-optional-panel__title">
                  Optional — only if different from parent BDF
                </div>
                <p className="sub-bdf-optional-panel__description">
                  Leave everything below empty to keep the same campaign name,
                  party company, and brand as the original BDF. Use these
                  fields only when this Sub BDF must override one or more of
                  them.
                </p>
              </div>

              <div className="sub-bdf-optional-fields">
                {renderSubBdfRoSection({
                  roFile: subBdfRoFile,
                  uploading: subBdfRoUploading,
                  inputId: "subBdfRoInput",
                  onFileSelect: handleSubBdfRoFileSelect,
                })}

                <div className="sub-bdf-field-group">
                  <label className="sub-bdf-label">
                    Campaign name
                    <span className="sub-bdf-optional-tag">(Optional)</span>
                  </label>
                  <p className="sub-bdf-field-hint">
                    Use when this Sub BDF needs a different campaign name than
                    the parent BDF.
                  </p>
                  <Input
                    size="middle"
                    className="sub-bdf-control"
                    style={{ width: "100%" }}
                    placeholder="Enter Campaign Name (Optional)"
                    value={campaignName}
                    onChange={(e) =>
                      setCampaignName(e.target.value.toUpperCase())
                    }
                  />
                </div>

                <div className="sub-bdf-field-group">
                  <label className="sub-bdf-label">
                    Party Company
                    <span className="sub-bdf-optional-tag">(Optional)</span>
                  </label>
                  <p className="sub-bdf-field-hint">
                    Select only if the Sub BDF should be billed or tracked under
                    a different party than the parent BDF.
                  </p>
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Select Party Company (Optional)"
                    size="middle"
                    className="sub-bdf-control"
                    style={{ width: "100%" }}
                    value={subBdfParentCompanyId}
                    options={partyMasterOptions.map((p) => ({
                      value: p._id,
                      label: p.partyName,
                    }))}
                    filterOption={(input, option) =>
                      (option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                    onChange={(value) => {
                      setSubBdfParentCompanyId(value ?? null);
                      setSubBdfBrandId(null);
                      if (value) {
                        fetchBrandsForParty(value);
                      } else {
                        setBrandsForParty([]);
                      }
                    }}
                  />
                </div>

                <div className="sub-bdf-field-group sub-bdf-field-group--last">
                  <label className="sub-bdf-label">
                    Brand
                    <span className="sub-bdf-optional-tag">(Optional)</span>
                  </label>
                  <p className="sub-bdf-field-hint">
                    Choose a brand under the party above when the Sub BDF
                    should use a different brand than the parent BDF.
                  </p>
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder={
                      subBdfParentCompanyId
                        ? "Select Brand (Optional)"
                        : "Select Party Company first"
                    }
                    size="middle"
                    className="sub-bdf-control"
                    style={{ width: "100%" }}
                    disabled={!subBdfParentCompanyId}
                    loading={brandsLoading}
                    value={subBdfBrandId}
                    options={brandsForParty.map((b) => ({
                      value: b._id,
                      label: b.brandName,
                    }))}
                    filterOption={(input, option) =>
                      (option?.label || "")
                        .toLowerCase()
                        .startsWith(input.toLowerCase())
                    }
                    onChange={(value) => setSubBdfBrandId(value ?? null)}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          title="Choose Inventories"
          open={subBdfInvPickerOpen}
          onOk={confirmSubBdfInvPicker}
          onCancel={closeSubBdfInvPicker}
          width={900}
          okText="Add Selected"
        >
          <Input
            placeholder="Search code, location, width, height..."
            value={subBdfPickerSearch}
            onChange={handleSubBdfPickerSearch}
            style={{ marginBottom: 16 }}
          />
          <div style={{ width: "100%", overflow: "auto" }}>
            <Table
              rowKey="_id"
              dataSource={subBdfPickerInvs}
              pagination={{ pageSize: 8 }}
              locale={{
                emptyText: "All available inventories are already added",
              }}
              columns={[
                { title: "Code No.", dataIndex: "codeNo", key: "codeNo" },
                { title: "Location", dataIndex: "location", key: "location" },
                { title: "Width", dataIndex: "width", key: "width" },
                { title: "Height", dataIndex: "height", key: "height" },
                { title: "Illu", dataIndex: "Illu", key: "Illu" },
                {
                  title: "Add",
                  key: "add",
                  render: (_, record) => (
                    <Checkbox
                      checked={record.checked}
                      onChange={(e) => handleSubBdfPickerCheckbox(e, record)}
                    />
                  ),
                },
              ]}
            />
          </div>
        </Modal>
      </div>
    </>
  );
};
